/* eslint-disable no-inner-declarations */
import {
    getTitleForCanvasElement,
    selectCanvasElements,
    toggleElementLock,
    toggleElementVisibility,
    toggleElementOverlay,
    focusCanvas,
    updateCanvasSelection,
    updateElementsOrderFromZIndex
} from '@/utils/elementsUtils';
import * as Sentry from '@sentry/browser';
import { buildCloudFrontUrl } from '@/utils/pathUtils';
import { imageToBlob, handleDownloadCurrentCanvasAsImage } from '@/utils/imageUtils';
import { UndoRedoManager } from '@/utils/undoRedoManager/undoRedoManager.js';
import * as starMapUtils from '../../services/util/starMapUtils';
import ImageFilter from '@/typings/ImageFilter';
import { generateCustomilyCalendar } from '@/utils/customilyCalendarUtils';
import fontManagerService from '@/utils/fontManagerService';
import { delay } from '@/utils/timingUtils';
import { cloneDeep } from 'lodash';
import { IndexDbService } from '../../services/util/indexDbService';
import { ImageEffectsService } from '@/utils/imageEffectsService';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('CreateStepTwoCtrl', createStepTwoCtrl);

    function createStepTwoCtrl(
        $scope,
        ProductService,
        ImageUtilService,
        MultipleFontService,
        $timeout,
        $location,
        $mdDialog,
        $rootScope,
        $sce,
        blockUI,
        TestImageService,
        ColorSamplerService,
        GeneralMathUtils,
        TextService,
        DynamicVectorService,
        DynamicImageService,
        MultipleFileUploadService,
        TextureService,
        LibrariesUtilService,
        LibrariesAPIService,
        $interval,
        ConfigService,
        ElementsColorService,
        AppCuesService,
        ColorPickerModalService,
        RemoveBgAPIService,
        ImageFiltersAPIService,
        PreviewUtilService,
        CutoutProUtilService,
        CustomilyRmbgService,
        CustomilyFaceCutOutService,
        CustomilyImageFilterService,
        CrosswordService,
        QrUtilService
    ) {
        $rootScope.headerMode = 'single';

        // Max image size to be used in the preview for background or when uploading dynamic images
        $scope.MAX_IMAGE_SIZE = ConfigService.MAX_PREVIEW_IMAGE_SIZE;

        $scope.bgColor = null;
        $scope.backgroundReady = false;
        $scope.backgroundType = null;
        $scope.bgColorPickerCtrlMethods = ColorSamplerService.createEmptyColorPicker();
        $scope.imageOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();

        $scope.previewMode = $location.$$path == '/createProduct3';
        // We'll consider that the user is editing an existing object if the preview had loaded text or pictures
        $scope.editMode =
            ProductService.getProduct().preview.textsPreview.length > 0 ||
            ProductService.getProduct().preview.imagePlaceHoldersPreview.length > 0 ||
            ProductService.getProduct().preview.circularTextsPreview.length > 0 ||
            ProductService.getProduct().preview.vectorEPSPreview.length > 0;
        $scope.colorSamplerActive = false;
        $scope.replacedBackground = false;
        $scope.textures = [];
        $scope.crosswordTextures = [];
        $scope.canRemoveSelection = false;

        $scope.bgColorForm = {
            previewWidth: 1000,
            previewHeight: 1000
        };

        // Library names
        $scope.selectedColorLibraryName = '';
        $scope.selectedFontLibraryName = '';
        $scope.selectedImageLibraryName = '';
        $scope.selectedVectorLibraryName = '';

        $scope.selectedSpotifyPlayer = null;
        $scope.textAsMaskStoredObjects = {};

        // Objects selection and properties
        $scope.textSelected = null;
        $scope.imageSelected = null;
        $scope.selectedTextProperties = {
            text: '',
            centerX: 0,
            centerY: 0,
            rotation: 0,
            fontPath: '',
            fontName: '',
            color: '#000000',
            id: 0,
            skewX: 0,
            skewY: 0,
            outlineWidth: 0,
            fontOption: 0,
            fontColorOption: 1,
            textures: [],
            locked: true,
            prefix: '',
            suffix: '',
            flipX: false,
            flipY: false,
            textureScale: 100,
            useAsMask: false
        };
        $scope.textOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();

        $scope.selectedImageProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            id: 0,
            fullColor: true,
            grading: false,
            opacity: 1,
            skewX: 0,
            skewY: 0,
            width: 0,
            height: 0,
            dynamicImageVariation: 1,
            dynamicImagesPath: null,
            canChangeColorLibrary: true,
            colorPosition: 1,
            removeWhiteBackground: false,
            RemoveBackground: false,
            locked: true,
            flipX: false,
            flipY: false,
            CrosswordConfig: null,
            calendarConfig: null,
            imageToImage: false,
            imageToImageConfig: null,
            imageEffects: null,
            enablePerspective: false,
            statusPerspectiveMode: false,
            clipPath: { scaleX: 1, x: 0, y: 0 },
            textMaskUuid: '',
            pageEpsId: undefined
        };
        $scope.imageColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.imageOutlineColorPicker = ColorSamplerService.createEmptyColorPicker();
        $scope.hasSelectedElement = false;
        $scope.hasLockedSelectedElement = false;
        $scope.apiKeys = {
            removeBg: null,
            vanceAi: null,
            cutoutPro: null
        };

        // SVG Group
        $scope.svgSelected = null;
        $scope.selectedSVGProperties = {
            centerX: 0,
            centerY: 0,
            skewX: 0,
            skewY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            id: 0,
            position: 1,
            allowUserUpload: false,
            colorPosition: 1,
            canChangeColorLibrary: true,
            applyColoring: false,
            isSolidBackground: false,
            locked: true,
            flipX: false,
            flipY: false,
            allowEdit: false
        };

        // Selected Object Group
        $scope.selectedObjectGroup = null;
        $scope.selectedObjectGroupProperties = {
            centerX: 0,
            centerY: 0,
            rotation: 0,
            width: 0,
            height: 0,
            locked: true,
            objectCount: 0
        };

        $scope.shProduct = $rootScope.shProduct;
        $scope.layersInstance = null;
        $scope.forProductTemplateCreation = !!$location.search().forProductTemplateCreation;
        $scope.isUserDesignCreation = !!$location.search().forUserDesignCreation;
        $scope.forMyProductBases = !!$location.search().forMyProductBases;
        $scope.enablePageEpsForPods = !!$location.search().enablePageEpsForPods;
        $scope.isPrintfulOrPrintify = $location.search().pod === 'Printful' || $location.search().pod === 'Printify';
        $scope.fromListing = !!$location.search().fromListing || false;
        $scope.elementAlignType = 'selection';
        $scope.enablePageEps =
            $scope.isPrintfulOrPrintify ||
            $scope.enablePageEpsForPods ||
            $scope.forMyProductBases ||
            !(
                $scope.isUserDesignCreation ||
                $scope.createDesignOnTemplate ||
                $scope.forDesignTemplateCreation ||
                $scope.forMyDesigns
            );

        $scope.showResetLayerModal = false;

        $scope.isPreviewElement = false;
        $scope.provider = ProductService.getPod()?.apiKeyReference;

        $scope.isGroupSelected = function () {
            if ($scope.isUserDesignCreation && !$scope.previewMode) {
                // If user is modifying a design all element should be treated as a group
                return true;
            } else {
                return canvas.getActiveObjects().length > 1;
            }
        };

        $scope.IndexDbService = new IndexDbService();

        $scope.$watch('layersInstance', (instance) => {
            $scope.layersInstance = instance;
        });

        $scope.showBlockUiLoader = function (active, message = 'Loading...') {
            if (!active) {
                blockUI.stop();
                return;
            }

            if (blockUI.state().blocking) {
                blockUI.message(message);
                return;
            }

            blockUI.start(message);
        };

        $scope.layersElementLockToggle = function (data) {
            if ($rootScope.isManagedUser && !$rootScope.user.UserImpersonatedFromId) return;
            toggleElementLock(data.element, canvas);

            const object = canvas.getActiveObject();
            if (object) {
                object.fire('modified');
            }

            $timeout(() => $scope.$apply());
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementVisibilityToggle = function (data) {
            toggleElementVisibility(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.layersElementOverlayToggle = function (data) {
            toggleElementOverlay(data.element, canvas);
            updateCanvasSelection(canvas);
            focusCanvas(canvas);
        };

        $scope.resetPreviewToggle = function () {
            $scope.isResetPreview = !$scope.isResetPreview;
        };

        $scope.layersTitleChange = function (data) {
            if ($scope.editMode && data.element.setEditedProp) {
                data.element.setEditedProp('name');
            }
            focusCanvas(canvas);
        };

        $rootScope.$watch('user', (user) => {
            if (!user) return;
            $scope.apiKeys = {
                removeBg: user.RemoveBgAPIKey,
                vanceAi: user.VanceAiAPIKey,
                cutoutPro: user.CutoutproAPIKey
            };
        });

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        $scope.$watch('backgroundReady', function (newVal, oldVal) {
            if ($scope.backgroundReady && !$scope.previewMode) {
                const title = `${ProductService.getProduct().name}: ${Number(canvas.getArtworkWidth()).toFixed(
                    0
                )}x${Number(canvas.getArtworkHeight()).toFixed(0)} px`;

                if ($scope.previewMode) {
                    $rootScope.headerTitleRight = title;
                } else {
                    $rootScope.headerTitleLeft = title;
                }
                $rootScope.headerMode = 'dual';
            }
        });

        if (AppCuesService.getCurrentFlow() == AppCuesService.WelcomeFlowCPart1) {
            window.Appcues?.show(AppCuesService.WelcomeFlowCPart2);
        }

        // Load Textures on startup
        $scope.loadTextures = function () {
            TextureService.getAllTextures().then(function (textures) {
                console.log('Textures Loaded');
                $scope.textures = textures;

                $scope.textures.forEach((texture) => {
                    texture.Name = texture.Name.replace(/\.[^/.]+$/, '');
                });
            });
        };

        $scope.toRgbaString = function (hex, alpha) {
            let converter = new Colors();
            let rgb = converter.convertColor(hex.replace('#', ''), 'HEX2RGB');
            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
        };

        $scope.bgColorPickerColorChange = function (color) {
            $scope.bgColor = color;
            $timeout(function () {
                $scope.$apply();
            });
        };

        $scope.onBgColorPickerReady = function () {
            // Set initial picker color
            $scope.bgColorPickerCtrlMethods.setColor('#ffffff');
            $scope.bgColorPickerCtrlMethods.openInContainer($('#step2-container #pickerContainer').get(0));
        };

        // We'll load textures only if there is text to apply them to
        const listEps = ProductService.getListEPS();
        if (listEps.length > 0 && listEps.some((s) => s.textsEps.length > 0)) {
            $scope.loadTextures();
        }

        $scope.isPreviewOnlyElement = function (object) {
            return ProductService.isPreviewOnlyElement(object);
        };

        const canDeleteObject = function (object) {
            return !(object instanceof fabric.Object) || $scope.isPreviewOnlyElement(object);
        };

        $scope.undoManager = $rootScope.planIncludesFeature ? new UndoRedoManager() : null;

        let canvas = new fabric.CanvasEx('fabric-canvas-2', {
            eventContainer: !$scope.previewMode ? 'fabric-container-2' : '',
            altActionKey: 'ctrlKey', // So we can control skew with the mouse
            preserveObjectStacking: true,
            seamLessScrollbars: $scope.previewMode,
            enableZoom: !$scope.previewMode,
            artworkTitle: $scope.previewMode ? 'Preview' : '',
            isPreviewStep: true,
            enableCopyPaste: function (objects) {
                if (objects.length && !$scope.isUserDesignCreation) {
                    // If any of the selected objects is not a preview-only object, don't allow copy-pasting
                    for (const object of objects) {
                        if (!$scope.isPreviewOnlyElement(object)) {
                            return false;
                        }
                    }
                }
                return true;
            },
            enableGroups: $scope.enableGroups,
            undoManager: $scope.undoManager,
            enablePageEps: $scope.enablePageEps,
            editMode: $scope.editMode,
            displayGuidelines: true
        });
        canvas.canDeleteObject = canDeleteObject;
        $scope.canvas = canvas;
        $scope.stepTwoLayersSettingsProps = {
            canvas: $scope.canvas
        };

        $scope.loadSelectedObjectGroupData = function (evt) {
            if (canvas.getActiveObject()?.isType('activeSelection')) {
                $scope.selectedObjectGroup = canvas.getActiveObject();
            } else {
                canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                canvas.off('customilyActiveSelection:modified');
                $scope.selectedObjectGroup = null;
                return;
            }

            const point = $scope.selectedObjectGroup.getPointByOrigin('center', 'center');

            if (!evt || evt.skipCenterX === undefined || !evt.skipCenterX) {
                $scope.selectedObjectGroupProperties.centerX = point.x;
            }
            if (!evt || evt.skipCenterY === undefined || !evt.skipCenterY) {
                $scope.selectedObjectGroupProperties.centerY = point.y;
            }
            if (!evt || evt.skipRotation === undefined || !evt.skipRotation) {
                $scope.selectedObjectGroupProperties.rotation = $scope.selectedObjectGroup.angle;
            }
            if (!evt || evt.skipWidth === undefined || !evt.skipWidth) {
                $scope.selectedObjectGroupProperties.width = $scope.selectedObjectGroup.getScaledWidth();
            }
            if (!evt || evt.skipHeight === undefined || !evt.skipHeight) {
                $scope.selectedObjectGroupProperties.height = $scope.selectedObjectGroup.getScaledHeight();
            }
            $scope.selectedObjectGroupProperties.locked = false;
            $scope.selectedObjectGroupProperties.objectCount = $scope.selectedObjectGroup.getObjects()?.length;

            $timeout(function () {
                $scope.$apply();
            });
        };

        const itemSelected = function (event) {
            const target = event.target;
            // If the target is a perspective control, don't allow the selection
            if (target?.isPerspectiveControl) {
                return;
            }

            $scope.canRemoveSelection = canDeleteObject(canvas.getActiveObject());
            $scope.isPreviewElement = ProductService.isPreviewOnlyElement(canvas.getActiveObject());
            // Disable multiple elements control when a locked element is selected
            $scope.hasLockedSelectedElement =
                canvas.getActiveObject().locked || canvas.getActiveObject()?._objects?.some((item) => item.locked);
            // When selection multiple elements, disable the control panel
            if ($scope.isGroupSelected() && event.target.type === 'activeSelection') {
                event.target.set('lockUniScaling', true);
                // Hide non-uniform scaling controls for multiple selections to prevent proportion loss
                event.target.set('_controlsVisibility', {
                    ml: false, // middle left (scaleX)
                    mr: false, // middle right (scaleX)
                    mt: false, // middle top (scaleY)
                    mb: false, // middle bottom (scaleY)
                    tl: true, // top left (uniform scaling)
                    tr: true, // top right (uniform scaling)
                    bl: true, // bottom left (uniform scaling)
                    br: true // bottom right (uniform scaling)
                });
                canvas.requestRenderAll();
                $scope.hasSelectedElement = true;

                if ($scope.selectedObjectGroup !== event.target) {
                    $scope.selectedObjectGroup = event.target;
                }

                if (!$scope.selectedObjectGroup && canvas.getActiveObject()?.isType('activeSelection')) {
                    $scope.selectedObjectGroup = canvas.getActiveObject();
                }

                $scope.loadSelectedObjectGroupData();

                canvas.on('object:modified', $scope.loadSelectedObjectGroupData);
                canvas.on('customilyActiveSelection:modified', $scope.loadSelectedObjectGroupData);

                setTimeout(function () {
                    $scope.$apply();
                });
            } else {
                if (!$scope.isUserDesignCreation) {
                    $scope.hasSelectedElement = true;

                    // Terminate all opened color pickers so they can restore the current element color if it wasn't saved and
                    //  other element was now selected
                    $scope.textOutlineColorPicker.terminate();
                    $scope.imageColorPicker.terminate();
                    $scope.imageOutlineColorPicker.terminate();

                    $scope.textSelected = null;
                    $scope.imageSelected = null;
                    $scope.svgSelected = null;
                    if ($scope.selectedObjectGroup) {
                        canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                        canvas.off('customilyActiveSelection:modified');
                        $scope.selectedObjectGroup = null;
                    }

                    canvas.updateCornerSize(canvas.getActiveObject());

                    const parentGroupId = canvas.getActiveObject()?.groupId;
                    if (parentGroupId) {
                        const parentGroup = canvas.elementsGroups.find((group) => group.id === parentGroupId);
                        if (parentGroup && parentGroup.SpotifyPlayer) {
                            $scope.selectedSpotifyPlayer = parentGroup;
                        } else {
                            $scope.selectedSpotifyPlayer = null;
                        }
                    } else {
                        $scope.selectedSpotifyPlayer = null;
                    }

                    // Text selected
                    if (
                        canvas.getActiveObject() &&
                        (canvas.getActiveObject().type == 'bounded-text' ||
                            canvas.getActiveObject().type == 'text-transform')
                    ) {
                        $scope.textSelected = canvas.getActiveObject();
                        LibrariesUtilService.updateLibraryNames($scope, $scope.textSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadTextData() {
                            if (!$scope.textSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedTextProperties.text = $scope.textSelected.getText();
                            $scope.selectedTextProperties.centerX = $scope.textSelected.left;
                            $scope.selectedTextProperties.centerY = $scope.textSelected.top;
                            $scope.selectedTextProperties.width = $scope.textSelected.getWidth();
                            $scope.selectedTextProperties.height = $scope.textSelected.getHeight();
                            $scope.selectedTextProperties.rotation = $scope.textSelected.angle;
                            $scope.selectedTextProperties.fontPath = $scope.textSelected.fontPath;
                            $scope.selectedTextProperties.fontOption = $scope.textSelected.fontOption || 1;
                            $scope.selectedTextProperties.fontColorOption = $scope.textSelected.fontColorOption || 1;
                            $scope.selectedTextProperties.id = $scope.textSelected.id;
                            $scope.selectedTextProperties.skewX = $scope.textSelected.skewX;
                            $scope.selectedTextProperties.skewY = $scope.textSelected.skewY;
                            $scope.selectedTextProperties.outlineWidth = $scope.textSelected.getOutlineWidth();
                            $scope.selectedTextProperties.Itext = $scope.textSelected.Itext;
                            $scope.selectedTextProperties.locked = $scope.textSelected.locked;
                            $scope.selectedTextProperties.prefix = $scope.textSelected.prefix;
                            $scope.selectedTextProperties.suffix = $scope.textSelected.suffix;
                            $scope.selectedTextProperties.allowEdit = $scope.textSelected.allowEdit;
                            const flip = $scope.textSelected.getFlip();
                            $scope.selectedTextProperties.flipX = flip.flipX || false;
                            $scope.selectedTextProperties.flipY = flip.flipY || false;
                            $scope.selectedTextProperties.useAsMask = $scope.textSelected.useAsMask;

                            //update [0] to [selectedIndex]
                            if ($scope.textSelected.textures && $scope.textSelected.textures[0]) {
                                $scope.selectedTextProperties.texture = $scope.textSelected.textures[0].texturePath;
                                $scope.selectedTextProperties.textureScale =
                                    $scope.textSelected.textures[0].textureScale || 100;
                            } else {
                                $scope.selectedTextProperties.texture = 'null';
                            }

                            // Don't allow removing or changing the color library if it was already assigned on step 1
                            $scope.selectedTextProperties.canChangeColorLibrary = true;
                            let element = ProductService.getEpsElementFromPreviewElement($scope.textSelected);
                            if (element) {
                                const roles = $rootScope.user.AccessRoles.Serialized.split(',');
                                if (element.colorLibraryId && !roles.includes('can-change-color-library-step-two')) {
                                    $scope.selectedTextProperties.canChangeColorLibrary = false;
                                }
                            } else {
                                console.warn('No EPS element with ID ' + $scope.selectedTextProperties.id);
                            }

                            // Compute the new max and min font sizes according to the object size
                            let size = GeneralMathUtils.calculateFontSizesFromObject($scope.textSelected);
                            $scope.textSelected.setMinSizePx(size.min);
                            $scope.textSelected.setMaxSizePx(size.max);

                            if ($scope.textSelected.allowEdit && $scope.textSelected.originalInitCenterX != null) {
                                const values = GeneralMathUtils.calculateInitTextValuesFromObject($scope.textSelected);
                                $scope.textSelected.setInitPositionAndSize(
                                    values.initCenterX,
                                    values.initCenterY,
                                    values.initFontSize
                                );
                            }
                        }

                        loadTextData();

                        $scope.textSelected.on({
                            modified: function () {
                                loadTextData();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });

                        if (
                            $scope.textSelected.id == $scope.getLastObjectId() &&
                            AppCuesService.getCurrentFlow() == AppCuesService.OptionBPart7
                        ) {
                            window.Appcues?.show(AppCuesService.OptionBPart8);
                        }
                    }
                    // Circular text selected
                    else if (canvas.getActiveObject() && canvas.getActiveObject().type == 'path-itext') {
                        $scope.textSelected = canvas.getActiveObject();
                        LibrariesUtilService.updateLibraryNames($scope, $scope.textSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadCircularTextData() {
                            if (!$scope.textSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedTextProperties.text = $scope.textSelected.text;
                            $scope.selectedTextProperties.centerX = $scope.textSelected.left;
                            $scope.selectedTextProperties.centerY = $scope.textSelected.top;
                            $scope.selectedTextProperties.rotation = $scope.textSelected.angle;
                            $scope.selectedTextProperties.verticalDiameter = $scope.textSelected.verticalDiameter;
                            $scope.selectedTextProperties.horizontalDiameter = $scope.textSelected.horizontalDiameter;
                            $scope.selectedTextProperties.skewX = $scope.textSelected.skewX;
                            $scope.selectedTextProperties.skewY = $scope.textSelected.skewY;

                            $scope.selectedTextProperties.caps = $scope.textSelected.caps;
                            $scope.selectedTextProperties.fontPath = $scope.textSelected.fontPath;
                            $scope.selectedTextProperties.fontOption = $scope.textSelected.fontOption || 1;
                            $scope.selectedTextProperties.fontColorOption = $scope.textSelected.fontColorOption || 1;
                            $scope.selectedTextProperties.id = $scope.textSelected.id;
                            $scope.selectedTextProperties.outlineColor = $scope.textSelected.stroke;
                            $scope.selectedTextProperties.outlineWidth = $scope.textSelected.strokeWidth;
                            $scope.selectedTextProperties.locked = $scope.textSelected.locked;
                            $scope.selectedTextProperties.prefix = $scope.textSelected.prefix;
                            $scope.selectedTextProperties.suffix = $scope.textSelected.suffix;
                            const flip = $scope.textSelected.getFlip();
                            $scope.selectedTextProperties.flipX = flip.flipX || false;
                            $scope.selectedTextProperties.flipY = flip.flipY || false;

                            canvas.renderAll();

                            $scope.selectedTextProperties.fontSize = $scope.textSelected.fontSize;

                            // Don't allow removing or changing the color library if it was already assigned on step 1
                            $scope.selectedTextProperties.canChangeColorLibrary = true;
                            let element = ProductService.getEpsElementFromPreviewElement($scope.textSelected);
                            if (element) {
                                const roles = $rootScope.user.AccessRoles.Serialized.split(',');
                                if (element.colorLibraryId && !roles.includes('can-change-color-library-step-two')) {
                                    $scope.selectedTextProperties.canChangeColorLibrary = false;
                                }
                            } else {
                                console.warn('No EPS element with ID ' + $scope.selectedTextProperties.id);
                            }
                        }
                        loadCircularTextData();

                        $scope.textSelected.on({
                            modified: function () {
                                loadCircularTextData();
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // Image placeholder or dynamic image selected
                    else if (canvas.getActiveObject() && canvas.getActiveObject().type == 'image-placeholder') {
                        $scope.imageSelected = canvas.getActiveObject();
                        LibrariesUtilService.updateLibraryNames($scope, $scope.imageSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadImageData() {
                            if (!$scope.imageSelected) {
                                return;
                            }
                            // Load data
                            $scope.selectedImageProperties.centerX = $scope.imageSelected.left;
                            $scope.selectedImageProperties.centerY = $scope.imageSelected.top;
                            $scope.selectedImageProperties.rotation = $scope.imageSelected.angle;
                            $scope.selectedImageProperties.id = $scope.imageSelected.id;
                            $scope.selectedImageProperties.fullColor = $scope.imageSelected.fullColor;
                            $scope.selectedImageProperties.grading = $scope.imageSelected.grading;
                            $scope.selectedImageProperties.opacity = $scope.imageSelected.getOpacity();
                            $scope.selectedImageProperties.skewX = $scope.imageSelected.skewX;
                            $scope.selectedImageProperties.skewY = $scope.imageSelected.skewY;
                            $scope.selectedImageProperties.width = $scope.imageSelected.getWidth();
                            $scope.selectedImageProperties.height = $scope.imageSelected.getHeight();
                            $scope.selectedImageProperties.hasStaticImage = $scope.imageSelected.hasStaticImage;
                            $scope.selectedImageProperties.dynamicImagesPath = $scope.imageSelected.dynamicImagesPath;
                            $scope.selectedImageProperties.imageUrl = $scope.imageSelected.imageUrl;
                            $scope.selectedImageProperties.dynamicImageVariation =
                                $scope.imageSelected.dynamicImageVariation || 1;
                            $scope.selectedImageProperties.removeWhiteBackground =
                                $scope.imageSelected.removeWhiteBackground;
                            $scope.selectedImageProperties.cartoonize = $scope.imageSelected.cartoonize;
                            $scope.selectedImageProperties.CutoutFace = $scope.imageSelected.CutoutFace;
                            $scope.selectedImageProperties.removeBackgroundCOP =
                                $scope.imageSelected.removeBackgroundCOP;
                            $scope.selectedImageProperties.CustomilyRemoveBackground =
                                $scope.imageSelected.CustomilyRemoveBackground;
                            $scope.selectedImageProperties.CustomilyFaceCutOut =
                                $scope.imageSelected.CustomilyFaceCutOut;
                            $scope.selectedImageProperties.CustomilyImageFilter =
                                $scope.imageSelected.CustomilyImageFilter;
                            $scope.selectedImageProperties.isPencilDrawingActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.PENCIL;
                            $scope.selectedImageProperties.isAquaFilterActive =
                                $scope.imageSelected.CustomilyImageFilter === ImageFilter.AQUA;
                            ($scope.selectedImageProperties.RemoveBackground = $scope.imageSelected.RemoveBackground),
                                ($scope.selectedImageProperties.locked = $scope.imageSelected.locked);
                            const flip = $scope.imageSelected.getFlip();
                            $scope.selectedImageProperties.CrosswordConfig = $scope.imageSelected.CrosswordConfig;
                            $scope.selectedImageProperties.crossword = $scope.imageSelected.crossword;
                            $scope.selectedImageProperties.calendarConfig = $scope.imageSelected.calendarConfig;
                            $scope.selectedImageProperties.imageToImageConfig = $scope.imageSelected.imageToImageConfig;
                            $scope.selectedImageProperties.imageToImage = $scope.imageSelected.imageToImage;
                            $scope.selectedImageProperties.imageEffects = $scope.imageSelected.imageEffects;
                            $scope.selectedImageProperties.calendar = $scope.imageSelected.calendar;
                            $scope.selectedImageProperties.flipX = flip.flipX || false;
                            $scope.selectedImageProperties.flipY = flip.flipY || false;
                            $scope.selectedImageProperties.initWidth = $scope.imageSelected.initWidth;
                            $scope.selectedImageProperties.initHeight = $scope.imageSelected.initHeight;
                            $scope.selectedImageProperties.initCenterX = $scope.imageSelected.initCenterX;
                            $scope.selectedImageProperties.initCenterY = $scope.imageSelected.initCenterY;
                            $scope.selectedImageProperties.initRotation = $scope.imageSelected.initRotation;

                            // Set image mode
                            if (!$scope.imageSelected.fullColor && !$scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'single color';
                            } else if (!$scope.imageSelected.fullColor && $scope.imageSelected.grading) {
                                $scope.selectedImageProperties.imageType = 'grading';
                            } else {
                                $scope.selectedImageProperties.imageType = 'full color';
                            }
                            $scope.selectedImageProperties.outlineWidth = $scope.imageSelected.outlineWidth;
                            $scope.selectedImageProperties.outlineColor = $scope.imageSelected.outlineColor;

                            $scope.selectedImageProperties.enablePerspective =
                                $scope.imageSelected.enablePerspective || false;
                            $scope.selectedImageProperties.statusPerspectiveMode =
                                $scope.imageSelected.__perspectiveMode;

                            $scope.imageColorPicker.setColor($scope.imageSelected.getColor());
                            if ($scope.imageSelected.outlineWidth > 0 && $scope.imageSelected.outlineColor) {
                                $scope.imageOutlineColorPicker.setColor($scope.imageSelected.outlineColor);
                            }
                            if (
                                !$scope.selectedImageProperties.textMaskUuid &&
                                $scope.selectedImageProperties.clipPath &&
                                $scope.imageSelected.clipPath
                            ) {
                                $scope.selectedImageProperties.clipPath.scaleX = $scope.imageSelected.clipPath.scaleX;
                                $scope.selectedImageProperties.clipPath.x = $scope.imageSelected.clipPath.left;
                                $scope.selectedImageProperties.clipPath.y = $scope.imageSelected.clipPath.top;
                            }
                        }
                        loadImageData();

                        if (
                            $scope.imageSelected.id == 3 &&
                            AppCuesService.getCurrentFlow() == AppCuesService.OptionBPart8
                        ) {
                            window.Appcues?.show(AppCuesService.OptionBPart9);
                        }

                        $scope.imageSelected.on({
                            modified: function () {
                                loadImageData();
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }
                    // Vector placeholder or dynamic vector selected
                    else if (canvas.getActiveObject() && canvas.getActiveObject().type == 'vector-placeholder') {
                        $scope.svgSelected = canvas.getActiveObject();
                        $scope.selectedSVGProperties.position = $scope.svgSelected.selectedPosition;
                        $scope.selectedSVGProperties.colorPosition = $scope.svgSelected.selectedColorPosition;
                        LibrariesUtilService.updateLibraryNames($scope, $scope.svgSelected);

                        // eslint-disable-next-line no-inner-declarations
                        function loadSVGGroupData() {
                            if (!$scope.svgSelected) {
                                return;
                            }
                            $scope.selectedSVGProperties.centerX = $scope.svgSelected.left;
                            $scope.selectedSVGProperties.centerY = $scope.svgSelected.top;
                            $scope.selectedSVGProperties.rotation = $scope.svgSelected.angle;
                            $scope.selectedSVGProperties.width = $scope.svgSelected.width * $scope.svgSelected.scaleX;
                            $scope.selectedSVGProperties.height = $scope.svgSelected.height * $scope.svgSelected.scaleY;
                            $scope.selectedSVGProperties.id = $scope.svgSelected.id;
                            $scope.selectedSVGProperties.allowUserUpload = $scope.svgSelected.allowUserUpload;
                            $scope.selectedSVGProperties.applyColoring = $scope.svgSelected.applyColoring;
                            $scope.selectedSVGProperties.isSolidBackground = $scope.svgSelected.isSolidBackground;
                            $scope.selectedSVGProperties.skewX = $scope.svgSelected.skewX;
                            $scope.selectedSVGProperties.skewY = $scope.svgSelected.skewY;
                            $scope.selectedSVGProperties.locked = $scope.svgSelected.locked;
                            const flip = $scope.svgSelected.getFlip();
                            $scope.selectedSVGProperties.flipX = flip.flipX || false;
                            $scope.selectedSVGProperties.flipY = flip.flipY || false;
                            $scope.selectedSVGProperties.allowEdit = $scope.svgSelected.allowEdit;
                            $scope.selectedSVGProperties.qrConfig = undefined;

                            // load qr
                            const qrConfig =
                                typeof $scope.svgSelected.qrConfig == 'string'
                                    ? JSON.parse($scope.svgSelected.qrConfig)
                                    : $scope.svgSelected.qrConfig;

                            if (qrConfig) {
                                $scope.selectedSVGProperties.qrConfig = { ...qrConfig };
                                $scope.svgSelected.qrConfig = { ...qrConfig };

                                if (!$scope.previewMode) {
                                    $timeout(() => {
                                        $scope.displayQrWithConfig(qrConfig, $scope.svgSelected);
                                    }, 300);
                                }
                            }

                            // Don't allow removing or changing the color library if it was already assigned on step 1
                            $scope.selectedSVGProperties.canChangeColorLibrary = true;
                            let element = ProductService.getEpsElementFromPreviewElement($scope.svgSelected);
                            if (element) {
                                if (element.colorLibraryId) {
                                    $scope.selectedSVGProperties.canChangeColorLibrary = false;
                                }
                            } else {
                                console.warn('No EPS element with ID ' + $scope.selectedSVGProperties.id);
                            }
                        }
                        loadSVGGroupData();

                        $scope.svgSelected.on({
                            modified: function () {
                                loadSVGGroupData();
                                setTimeout(function () {
                                    $scope.$apply();
                                });
                            }
                        });
                    }

                    $timeout(function () {
                        $scope.$apply();
                    });
                }
            }

            // Focus the canvas container to be able to use keys right away
            if (canvas.eventContainer) {
                $('#' + canvas.eventContainer)[0].focus({
                    preventScroll: true
                });
            }
        };

        canvas.on({
            'object:scaling': function () {
                if (canvas.getActiveObject() && canvas.getActiveObject().type == 'path-itext') {
                    $scope.textSelected = canvas.getActiveObject();

                    // Compute the scaled font size based on the size of the element
                    var fontSize = GeneralMathUtils.calculateCircularFontSizeFromDimensions(
                        $scope.textSelected.horizontalDiameter,
                        $scope.textSelected.originalHorizontalDiameter,
                        $scope.textSelected.originalFontSize
                    );

                    $scope.textSelected.set('fontSize', fontSize);

                    const { min, max } = GeneralMathUtils.calculateFontSizesFromDimensions(
                        $scope.textSelected.horizontalDiameter,
                        $scope.textSelected.originalHorizontalDiameter,
                        $scope.textSelected.originalMinSizePx,
                        $scope.textSelected.originalMaxSizePx
                    );
                    $scope.textSelected.set('minSizePx', min);
                    $scope.textSelected.set('maxSizePx', max);

                    $scope.selectedTextProperties.fontSize = $scope.textSelected.fontSize;
                    $scope.selectedTextProperties.minSizePx = $scope.textSelected.minSizePx;
                    $scope.selectedTextProperties.maxSizePx = $scope.textSelected.maxSizePx;
                }
            },
            'object:added': function () {
                if ($scope.isUserDesignCreation && !$scope.previewMode) {
                    // If it is a design then select all elements, no matter if it is just one.
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },
            'object:removed': function () {
                // Update the layers view when removing elements
            },
            /*'object:selected': function () {
                if ($scope.isUserDesignCreation && !$scope.previewMode) {
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },*/
            'object:modified': function (e) {
                // Selection group was modified?
                const selection = canvas.getActiveObjects();
                if (selection.length > 1 && e.target.type === 'activeSelection') {
                    canvas.temporaryDiscardActiveObject(() => {
                        // Update elements sizes according to the current scaled that was applied
                        //  in the group selection
                        for (const element of selection) {
                            element.updateFromGroupScaling();

                            if (element.type === 'path-itext') {
                                // Compute the scaled font size based on the size of the element
                                const fontSize = GeneralMathUtils.calculateCircularFontSizeFromDimensions(
                                    element.horizontalDiameter,
                                    element.originalHorizontalDiameter,
                                    element.originalFontSize
                                );

                                const { min, max } = GeneralMathUtils.calculateFontSizesFromDimensions(
                                    element.horizontalDiameter,
                                    element.originalHorizontalDiameter,
                                    element.originalMinSizePx,
                                    element.originalMaxSizePx
                                );

                                element.set('fontSize', fontSize);
                                element.set('minSizePx', min);
                                element.set('maxSizePx', max);
                            } else if (element.type === 'bounded-text') {
                                // Compute the new max and min font sizes according to the object size
                                let size = GeneralMathUtils.calculateFontSizesFromObject(element);
                                element.setMinSizePx(size.min);
                                element.setMaxSizePx(size.max);

                                if (element.allowEdit && element.originalInitCenterX != null) {
                                    const values = GeneralMathUtils.calculateInitTextValuesFromObject(element);
                                    element.setInitPositionAndSize(
                                        values.initCenterX,
                                        values.initCenterY,
                                        values.initFontSize
                                    );
                                }
                            }

                            canvas.requestRenderAll();
                            element.updateFromGroupScaling();
                        }
                    });
                    canvas.requestRenderAll();
                }
                const activeObject = canvas.getActiveObject();
                // Ensure multiple selections always maintain uniform scaling to preserve proportions
                if (activeObject && activeObject.type === 'activeSelection') {
                    activeObject.set('lockUniScaling', true);
                    // Hide non-uniform scaling controls for multiple selections
                    activeObject.set('_controlsVisibility', {
                        ml: false, // middle left (scaleX)
                        mr: false, // middle right (scaleX)
                        mt: false, // middle top (scaleY)
                        mb: false, // middle bottom (scaleY)
                        tl: true, // top left (uniform scaling)
                        tr: true, // top right (uniform scaling)
                        bl: true, // bottom left (uniform scaling)
                        br: true // bottom right (uniform scaling)
                    });
                }
                // apply text mask
                canvas.fire('object:handle:textmask', { target: e.target });
            },
            'selection:created': (data) => {
                itemSelected(data);
            },
            'selection:updated': (data) => {
                itemSelected(data);
            },
            'selection:cleared': function (event) {
                $scope.textOutlineColorPicker.terminate();
                $scope.imageColorPicker.terminate();
                $scope.imageOutlineColorPicker.terminate();

                $scope.textSelected = null;
                $scope.imageSelected = null;
                $scope.svgSelected = null;
                $scope.hasSelectedElement = false;
                $scope.selectedSpotifyPlayer = null;

                if ($scope.selectedObjectGroup) {
                    canvas.off('object:modified', $scope.loadSelectedObjectGroupData);
                    canvas.off('customilyActiveSelection:modified');
                    $scope.selectedObjectGroup = null;
                }

                $timeout(function () {
                    $scope.$apply();
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            'mouse:up': function (event) {
                if (
                    $scope.isUserDesignCreation &&
                    canvas.getActiveObject() &&
                    canvas.getObjects() &&
                    canvas.getActiveObject().length !== 0 &&
                    canvas.getActiveObject().length !== canvas.getObjects().length &&
                    !$scope.previewMode
                ) {
                    selectCanvasElements(canvas.getObjects(), canvas, true);
                }
            },
            'mouse:down': function (event) {
                if ($scope.colorSamplerActive) {
                    ColorSamplerService.processColorSelection(event.e, function (colorPicker, type, object) {
                        let color = '#' + colorPicker.getColor('HEX');
                        if (type === 'fill') {
                            // Re-select the elements and set the colors
                            if (object.type === 'bounded-text' || object.type === 'path-itext') {
                                if (object.setColor) {
                                    object.setColor(color);
                                } else {
                                    object.set('fill', color);
                                }
                                MultipleFontService.saveFontColorToOption(
                                    colorPicker.getColors(),
                                    object,
                                    $scope.editMode
                                );
                                canvas.setActiveObject(object);
                            } else if (object.type === 'image-placeholder') {
                                cancelNextImageColorChangeDebounced = true;
                                $scope.imageColorSave(colorPicker.getColors(), object);
                            }
                        } else if (type === 'outline') {
                            if (object.type === 'bounded-text' || object.type === 'path-itext') {
                                // Save the outline color
                                if (object.type === 'bounded-text') {
                                    let color = colorPicker.getColor();
                                    object.outlineColor = MultipleFontService.createColorObj({
                                        hex: '#' + color.HEX,
                                        cmyk: `${color.cmyk.c},${color.cmyk.m},${color.cmyk.y},${color.cmyk.k}`
                                    });
                                }

                                if (object.setOutlineColor) {
                                    object.setOutlineColor(color);
                                    canvas.renderAll();
                                } else {
                                    object.set('stroke', color);
                                }
                                canvas.setActiveObject(object);
                            }
                        }
                        $scope.colorSamplerActive = false;
                    });
                }
            },
            'object:handle:textmask': async function (event) {
                // apply text mask
                if (event && event.target) {
                    const activeObject = event.target;
                    let objects = [activeObject];
                    if (activeObject.type === 'activeSelection') {
                        objects = activeObject.getObjects?.() || [];
                    }
                    if (objects?.length > 0) {
                        for (const object of objects.filter(
                            (o) =>
                                (o.type === 'bounded-text' && o.useAsMask) ||
                                (o.type === 'image-placeholder' && o.textMaskUuid)
                        )) {
                            const uuid = object.type === 'bounded-text' ? object.uuid : object.textMaskUuid;
                            await $scope.applyTextMask(uuid);
                        }
                    }
                }
            },
            'before:transform': function () {
                const selection = canvas.getActiveObject();
                // Ensure multiple selections always maintain uniform scaling to preserve proportions
                if (selection && selection.type === 'activeSelection') {
                    selection.set('lockUniScaling', true);
                    // Hide non-uniform scaling controls for multiple selections
                    selection.set('_controlsVisibility', {
                        ml: false, // middle left (scaleX)
                        mr: false, // middle right (scaleX)
                        mt: false, // middle top (scaleY)
                        mb: false, // middle bottom (scaleY)
                        tl: true, // top left (uniform scaling)
                        tr: true, // top right (uniform scaling)
                        bl: true, // bottom left (uniform scaling)
                        br: true // bottom right (uniform scaling)
                    });
                }
            },
            'files:pasted': async function (event) {
                const { images, vectors } = event;
                const object = canvas.getActiveObject();
                const type = object ? $scope.getObjectType(object) : null;

                if (vectors.length && type == 'vector-placeholder') {
                    await $scope.displaySVGOnPlaceholder(vectors);
                }

                if (images.length) {
                    if (type == 'image-placeholder') {
                        await $scope.uploadImagesOnPlaceholder({ files: images });
                    } else {
                        if (!type?.length || type != 'dynamic-image') {
                            $scope.addDynamicImage();
                        }
                        $scope.imageSelected = canvas.getActiveObject();
                        $timeout(() => {
                            canvas.fire('images:pasted', images);
                        });
                    }
                }
            }
        });

        // Options for preview mode
        if ($scope.previewMode) {
            // Disabled group selection on preview mode
            canvas.selection = false;

            canvas.setArtworkSize(
                ProductService.getProduct().preview.width,
                ProductService.getProduct().preview.height
            );

            // Listen for events to update text elements
            $scope.$on('updateText:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same text
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    $scope.updateText(data.text, object);
                }
            });

            // Listen for events to update text font
            $scope.$on('updateTextFont:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same font
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    MultipleFontService.changeFontOption(object, data.fontOption, canvas);
                }
            });

            // Listen for events to update text font color
            $scope.$on('updateTextFontColor:stepTwo', function (event, data) {
                // Look for the text with the same ID and set the same font color
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            (o.type === 'bounded-text' || o.type === 'path-itext' || o.type === 'text-transform')
                    );
                for (const object of objects) {
                    MultipleFontService.changeFontColorOption(null, object, data.fontColorOption, canvas);
                }
            });

            $scope.$on('updateDynamicImage:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter((o) => o.id === data.id && o.type === 'image-placeholder' && o.dynamicImagesPath);
                for (const object of objects) {
                    object.dynamicImagesPath = data.dynamicImagesPath;
                    DynamicImageService.showDynamicImage(canvas, object, data.option);
                }
            });

            // Listen for events to update dynamic image/vector position
            $scope.$on('updateDynamicElementOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            ((o.type === 'image-placeholder' && o.dynamicImagesPath) ||
                                (o.type === 'vector-placeholder' && !o.allowUserUpload))
                    );
                for (const object of objects) {
                    if (object.type === 'image-placeholder') {
                        DynamicImageService.showDynamicImage(canvas, object, data.option);
                    } else {
                        DynamicVectorService.changeDynamicEPSPosition(object, data.option, canvas);
                    }
                }
            });

            // Listen for events to upload images to image placeholders
            $scope.$on('uploadImagePlaceholder:stepTwo', async function (event, data) {
                const image = data.file;
                if (!image) return;

                if (
                    !$scope.selectedImageProperties.RemoveBackground &&
                    !$scope.selectedImageProperties.cartoonize &&
                    !$scope.selectedImageProperties.CutoutFace &&
                    !$scope.selectedImageProperties.removeBackgroundCOP &&
                    !$scope.selectedImageProperties.CustomilyRemoveBackground &&
                    !$scope.selectedImageProperties.CustomilyFaceCutOut &&
                    !$scope.selectedImageProperties.CustomilyImageFilter &&
                    !$scope.selectedImageProperties.imageEffects?.length
                ) {
                    TestImageService.previewImageOnPlaceholder(image, canvas, data.id);
                    return;
                }

                $scope.imageSelected.imageFile = image;

                // Cartoonize (VanceAi)
                if ($scope.selectedImageProperties.cartoonize && $scope.apiKeys.vanceAi) await $scope.cartoonize();
                if ($scope.selectedImageProperties.CutoutFace && $scope.apiKeys.cutoutPro)
                    await $scope.faceCutout(true);

                if ($scope.selectedImageProperties.removeBackgroundCOP && $scope.apiKeys.cutoutPro)
                    await $scope.faceCutout(false);

                // Remove background (remove.bg)
                if ($scope.selectedImageProperties.RemoveBackground && $scope.apiKeys.removeBg) await $scope.removeBg();

                if ($scope.selectedImageProperties.CustomilyRemoveBackground) await $scope.customilyRmbg();

                if ($scope.selectedImageProperties.CustomilyFaceCutOut) await $scope.CustomilyFaceCutOut();

                if ($scope.selectedImageProperties.CustomilyImageFilter)
                    await $scope.CustomilyImageFilter($scope.selectedImageProperties.CustomilyImageFilter);

                if ($scope.imageSelected.imageEffects?.length) {
                    try {
                        $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                        await ImageEffectsService.processImageEffects({
                            object: $scope.imageSelected,
                            canvas,
                            username: $rootScope.user.Username,
                            file: $scope.imageSelected.imageFile
                        });
                    } catch (error) {
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .title('We received an error:')
                                .htmlContent(error.message)
                                .ok('OK!')
                        );
                    } finally {
                        $scope.showBlockUiLoader(false);
                        $timeout(() => $scope.$apply());
                    }
                }
            });

            // Listen for events to update image placeholder color
            $scope.$on('updateImageColorOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === data.id &&
                            o.type === 'image-placeholder' &&
                            !o.dynamicImagesPath &&
                            !o.fullColor &&
                            !o.grading
                    );

                for (const object of objects) {
                    DynamicImageService.changeDynamicImageColorPosition(object, data.colorOption, null, canvas);
                }
            });

            $scope.$on('resetImageTestValue:stepTwo', async () => {
                const targetObject = canvas.getActiveObject();
                const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
                targetObject.testingUrl = '';
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: require('@/assets/images/photo-example.png')
                });
                $scope.IndexDbService.findAndEditValue(object.uuid, '');
            });

            $scope.$on('resetSvgTestValue:stepTwo', async () => {
                const { selectedSVGProperties } = $scope;
                const targetObject = canvas.getActiveObject();
                const object = canvas
                    .getObjects()
                    .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
                TestImageService.showStaticImageSvg(canvas, object, {
                    imageUrl: require('@/assets/images/vector-example.svg')
                });
                selectedSVGProperties.svgString = '';
                $scope.IndexDbService.findAndEditValue(object.uuid, '');
            });

            // Listen for events to update dynamic vector color
            $scope.$on('updateVectorColorOption:stepTwo', function (event, data) {
                const objects = canvas
                    .getObjects()
                    .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.applyColoring);

                for (const object of objects) {
                    DynamicVectorService.changeDynamicEPSColorPosition(object, data.colorOption, null, canvas);
                }
            });

            // Listen for events to upload vectors to vector placeholders
            $scope.$on('uploadVectorPlaceholder:stepTwo', async function (event, data) {
                if (data.file) {
                    const objects = canvas
                        .getObjects()
                        .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.allowUserUpload);
                    for (const object of objects) {
                        await DynamicVectorService.loadFileOnPlaceholder(data.file, object, canvas);
                    }
                }
            });

            // Listen for requests for canvas preview image
            $scope.$on('canvas:previewImageRequest:stepTwo', async function (event, data) {
                let dataUrl = '';

                $scope.deselectAll();

                const targetSize = data.size || 100;
                const result = await ImageUtilService.limitImageResolution(canvas.toDataURL(), targetSize, targetSize);
                dataUrl = result.base64;

                $rootScope.$broadcast('canvas:previewImageGenerated:stepTwo', {
                    dataUrl: dataUrl
                });
            });

            $scope.$on('canvas:select:stepTwo', (event, data) => {
                if (data.uuids) {
                    const objects = canvas
                        .getObjects()
                        .filter((e) => data.uuids.includes(e.uuid) || data.uuids.includes(e.zIndex));
                    if (objects) {
                        // Select canvas elements and allow selecting single elements even if they are locked
                        selectCanvasElements(objects, canvas, true);
                    }
                }
            });

            $scope.$on('uploadCustomilyCalendar', function (event, date) {
                $scope.customilyCalendar.date = date;
                $scope.onCalendarDateChange();
            });

            $scope.$on('canvas:callback', function (_event, data) {
                const { callback } = data;
                if (callback) {
                    callback({
                        canvas
                    });
                }
            });

            $scope.$on('canvas:update-layers-order', function (_event) {
                setTimeout(() => {
                    updateElementsOrderFromZIndex(canvas);
                });
            });

            $scope.$on('canvas:loaded:stepTwo', function (_event) {
                if ($scope.layersInstance) {
                    $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                }
            });

            // Listen for events to update Qr Codes
            $scope.$on('updateQrText:stepTwo', async function (event, data) {
                if (data.qrText) {
                    const objects = canvas
                        .getObjects()
                        .filter((o) => o.id === data.id && o.type === 'vector-placeholder' && o.qrConfig);
                    for (const object of objects) {
                        const qrConfig =
                            typeof object.qrConfig == 'string' ? JSON.parse(object.qrConfig) : object.qrConfig;

                        $scope.displayQrWithConfig({ ...qrConfig, text: data.qrText }, object);
                    }
                }
            });

            $scope.$on('setActiveElement:stepTwo', function (event, data) {
                const object = canvas.getObjects().find((o) => o.id === data.id);
                canvas.setActiveObject(object);
            });
        }

        const objectHasProp = (object, property) => {
            return (
                Object.prototype.hasOwnProperty.call(object, property) &&
                object[property] !== null &&
                object[property] !== undefined
            );
        };

        $scope.getObjectType = (object) => {
            if (!object) return;

            const hasProp = {
                dynamicImagesPath: objectHasProp(object, 'dynamicImagesPath'),
                mapConfig: objectHasProp(object, 'mapConfig'),
                starMapConfig: objectHasProp(object, 'starMapConfig'),
                qrConfig: objectHasProp(object, 'qrConfig'),
                allowUserUpload: objectHasProp(object, 'allowUserUpload')
            };
            const objectType = object?.type;

            const isImagePlaceholder = objectType === 'image-placeholder';
            const isDynamicImage = isImagePlaceholder && hasProp.dynamicImagesPath;
            const isMap = isImagePlaceholder && hasProp.mapConfig;
            const isOverlay = isImagePlaceholder && hasProp.isColorOptions;
            const isProductColors = isImagePlaceholder && hasProp.isOverlay;
            const isVectorPlaceholder = objectType === 'vector-placeholder' && hasProp.allowUserUpload;
            const isDynamicVector = objectType === 'vector-placeholder' && !hasProp.allowUserUpload;
            const isStarMap = isVectorPlaceholder && hasProp.starMapConfig;

            if (isImagePlaceholder && !isDynamicImage && !isMap && !isStarMap) {
                return 'image-placeholder';
            } else if (isDynamicImage && !isMap && !isStarMap && !isOverlay && !isProductColors) {
                return 'dynamic-image';
            } else if (isVectorPlaceholder && !isDynamicVector && !isStarMap) {
                return 'vector-placeholder';
            }

            return null;
        };

        $scope.getCurrentElementTitle = function () {
            if (canvas && canvas.getActiveObject) {
                let object = canvas.getActiveObject();
                return getTitleForCanvasElement(object);
            }

            return '';
        };

        $scope.deleteSelectedElements = function () {
            canvas.removeSelection();
        };

        $scope.onElementSelectedAlign = function (align) {
            const object = canvas.elementsSelectedAlign(align, $scope.elementAlignType, $scope.editMode);
            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.onElementAlignTypeChanged = function (alignType) {
            $scope.elementAlignType = alignType;
        };

        $scope.addProductImageElement = (event) => {
            const addElement = () => {
                const productImages = PreviewUtilService.addProductColorElement(canvas, null, 'Product images');
                canvas.moveTo(productImages, productImages.zIndex);
                canvas.setActiveObject(productImages, event);
                const btn = document.getElementById('uploadImageFile');
                setTimeout(() => btn.click(), 10);
            };

            const productElement = canvas.getObjects().find((o) => o.isColorOptions);
            if (productElement) {
                $mdDialog
                    .show(
                        $mdDialog
                            .confirm()
                            .title('Alert')
                            .textContent(
                                'This product already has product images, creating a new product image will replace the existing one. Do you wish tio continue?'
                            )
                            .ok('Yes, Replace Images')
                            .cancel('Cancel')
                    )
                    .then(() => {
                        canvas.remove(productElement);
                        addElement();
                        setTimeout(() => {
                            updateElementsOrderFromZIndex(canvas);
                        });
                    });
                return;
            }

            addElement();
            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });
        };

        $scope.addMask = () => {
            const mask = $scope.addDynamicImage();
            mask.set('isOverlay', true);
            mask.set('name', `Mask ${mask.id}`);
            mask.setEditedProp('isOverlay');
            mask.setEditedProp('name');
            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });
            canvas.renderAll();
        };

        $scope.startBackgroundReplace = function (inputId) {
            // Replace with another background image
            if (ProductService.getPreviewImage() || $scope.backgroundImageFile) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(false)
                        .title('Background Image Replace')
                        .htmlContent(
                            'The background image should be replaced with another of a similar size. Using a very different size can result in elements going outside of the preview, if that’s the case, we recommend using the <b>Reset Preview</b> option.' +
                                '<br /><br /> The current image size is <b>' +
                                canvas.getArtworkWidth() +
                                'x' +
                                canvas.getArtworkHeight() +
                                ' px</b>'
                        )
                        .ok('OK!')
                );

                // To trigger the input file dialog the action must come from the user input. So this dirty hacks attaches a click
                //  event to the OK button in the dialog created above and launches the input file dialog. It's dirty but it's the
                //  only way as it is a browser security limitation.
                const ref = $interval(function () {
                    if ($('md-dialog button').length) {
                        $('md-dialog button').on('click', function () {
                            $(this).off('click');
                            angular.element(document.querySelector('#' + inputId)).trigger('click');
                        });
                        $interval.cancel(ref);
                    }
                }, 100);
            } else {
                // Replace with another background color
                ColorPickerModalService.showPickerDialog(null, 'rgb').then((color) => {
                    // Set canvas background color
                    $scope.replacedBackground = true;
                    $scope.backgroundImageFile = null;
                    $scope.backgroundType = 'color';
                    ProductService.setPreviewImage(null);

                    canvas.setBackgroundColor($scope.toRgbaString(color.HEX, color.alpha), () => {
                        canvas.renderAll();
                        // apply text masks
                        $scope.applyTextMasks();
                    });
                });
            }
        };

        $scope.replaceImage = function (files) {
            if (files && files[0]) {
                // Read the file
                const fr = new FileReader();
                fr.onload = function () {
                    // Load the image
                    let img = new Image();
                    img.onload = async function () {
                        let imageFile = files[0];

                        // Check if the image is too big and resize it (alerting the user first)
                        if (img.width > $scope.MAX_IMAGE_SIZE || img.height > $scope.MAX_IMAGE_SIZE) {
                            blockUI.stop();
                            $timeout(() => $scope.$apply());

                            blockUI.start('Uploading Image');

                            // Resize the image
                            const { base64 } = await ImageUtilService.limitImageResolution(
                                img,
                                $scope.MAX_IMAGE_SIZE,
                                $scope.MAX_IMAGE_SIZE
                            );

                            img = await ImageUtilService.getImageFromSrc(base64);
                            imageFile = new File([await imageToBlob(img)], imageFile.name);
                        }

                        canvas.setArtworkSize(img.width, img.height);
                        $scope.backgroundImageFile = imageFile;

                        fabric.Image.fromURL(img.src, function (i) {
                            i.set({
                                width: canvas.getArtworkWidth(),
                                height: canvas.getArtworkHeight(),
                                originX: 'left',
                                originY: 'top'
                            });
                            canvas.setBackgroundColor('white');
                            canvas.setBackgroundImage(i, canvas.renderAll.bind(canvas));
                            $('#inputFileReplace')[0].value = null;

                            blockUI.stop();
                            $scope.backgroundType = 'image';
                            $scope.replacedBackground = true;
                            // apply text masks
                            $scope.applyTextMasks();
                            $timeout(function () {
                                $scope.$apply();
                            });
                        });
                    };
                    img.crossOrigin = 'Anonymous';
                    img.src = fr.result;
                };
                fr.readAsDataURL(files[0]);
                blockUI.start('Uploading Image');
            }
        };

        $scope.step1HasStarMaps = function () {
            const vectorEPSEps = ProductService.getListEPS()
                .filter((eps) => eps.vectorEPSEps)
                .flatMap((eps) => eps.vectorEPSEps);

            const hasStarMapConfigVector = vectorEPSEps.some((vector) => vector.starMapConfig);
            return hasStarMapConfigVector;
        };

        $scope.setBackgroundColor = function (width, height, bgColor) {
            blockUI.start('Loading Data');

            // Set canvas background color
            $scope.replacedBackground = true;
            $scope.backgroundImageFile = null;
            $scope.backgroundType = 'color';
            ProductService.setPreviewImage(null);

            canvas.clear();
            canvas.setArtworkSize(width, height);

            canvas.setBackgroundColor(
                typeof bgColor === 'string' ? bgColor : $scope.toRgbaString($scope.bgColor.HEX, $scope.bgColor.alpha),
                async function () {
                    canvas.renderAll();

                    $scope.backgroundReady = true;
                    if ($scope.step1HasStarMaps()) {
                        await starMapUtils.showCelestialContainer();
                    }
                    await delay(1000);
                    loadProduct(true).then(() => {
                        blockUI.stop();
                        $timeout(() => $scope.$apply());
                    });
                }
            );
        };

        $scope.resetPreview = function () {
            // Reset preview by asking to set background image or color again
            $scope.backgroundReady = false;
            $scope.handleResetLayerClose();
        };

        $scope.handleResetLayerOpen = function (reset) {
            if (reset) {
                $scope.resetPreview();
                return;
            }

            $scope.showResetLayerModal = true;
        };

        $scope.handleResetLayerClose = function () {
            $scope.showResetLayerModal = false;
        };

        $scope.loadCrosswordTextures = () => {
            if (!$scope.crosswordTextures.length) {
                CrosswordService.getAllTextures().then((textures) => {
                    textures.forEach((texture) => {
                        texture.Name = texture.Name.replace(/\.[^/.]+$/, '');
                        $scope.crosswordTextures.push(texture);
                    });
                });
            }
        };

        $scope.uploadImage = function (files) {
            if (files && files[0]) {
                $scope.backgroundReady = false;

                // Read the file
                blockUI.start('Uploading Image');
                const fr = new FileReader();
                fr.onload = function () {
                    // Load the image
                    let img = new Image();
                    img.onload = async function () {
                        let imageFile = files[0];

                        // Check if the image is too big and resize it (alerting the user first)
                        if (img.width > $scope.MAX_IMAGE_SIZE || img.height > $scope.MAX_IMAGE_SIZE) {
                            blockUI.stop();
                            $timeout(() => $scope.$apply());

                            // Resize the image
                            const { base64 } = await ImageUtilService.limitImageResolution(
                                img,
                                $scope.MAX_IMAGE_SIZE,
                                $scope.MAX_IMAGE_SIZE
                            );

                            img = await ImageUtilService.getImageFromSrc(base64);
                            imageFile = new File([await imageToBlob(img)], imageFile.name);
                        }

                        blockUI.stop();
                        blockUI.start('Loading');
                        $timeout(() => $scope.$apply());

                        // Set the image as the canvas background
                        canvas.clear();
                        canvas.setArtworkSize(img.width, img.height);
                        $scope.backgroundImageFile = imageFile;

                        fabric.Image.fromURL(img.src, async function (i) {
                            i.set({
                                width: canvas.getArtworkWidth(),
                                height: canvas.getArtworkHeight(),
                                originX: 'left',
                                originY: 'top'
                            });
                            canvas.setBackgroundColor('white');
                            canvas.setBackgroundImage(i, canvas.renderAll.bind(canvas));
                            ProductService.setPreviewBgColor(null);
                            $scope.backgroundReady = true;
                            $scope.backgroundType = 'image';
                            $('#inputFile')[0].value = null;
                            if ($scope.step1HasStarMaps()) {
                                await starMapUtils.showCelestialContainer();
                            }
                            await loadProduct(true);
                            blockUI.stop();
                            $scope.replacedBackground = true;
                            $timeout(() => $scope.$apply());
                        });
                    };
                    img.crossOrigin = 'Anonymous';
                    img.src = fr.result;
                };
                fr.readAsDataURL(files[0]);
            }
        };

        // Check if there's already a defined background image and load it
        if (ProductService.getPreviewImage() || ProductService.getPreviewBgColor()) {
            blockUI.start('Loading Data');

            canvas.clear();
            canvas.setArtworkSize(
                ProductService.getProduct().preview.width,
                ProductService.getProduct().preview.height
            );

            if (ProductService.getPreviewImage()) {
                // Set image as canvas background
                console.log('Loading preview background image');
                $scope.backgroundType = 'image';

                const imageUrl = buildCloudFrontUrl(ProductService.getPreviewImage());
                canvas.setBackgroundColor('white');
                fabric.Image.fromURL(
                    imageUrl,
                    (backgroundImage) => {
                        // Scale image to match the canvas size
                        backgroundImage.set({
                            originX: 'left',
                            originY: 'top'
                        });
                        backgroundImage.scaleToWidth(canvas.getArtworkWidth());

                        canvas.setBackgroundImage(
                            backgroundImage,
                            () => {
                                canvas.renderAll();

                                $scope.backgroundReady = true;
                                if ($scope.step1HasStarMaps()) {
                                    starMapUtils.showCelestialContainer().then(() => {
                                        loadProduct().then(() => {
                                            blockUI.stop();
                                            $timeout(() => $scope.$apply());
                                        });
                                    });
                                } else {
                                    loadProduct().then(() => {
                                        blockUI.stop();
                                        $timeout(() => $scope.$apply());
                                    });
                                }
                            },
                            {
                                originX: 'left',
                                originY: 'top'
                            }
                        );
                    },
                    {
                        crossOrigin: 'anonymous'
                    }
                );
            } else {
                // Set canvas background color
                console.log('Loading preview background color');
                $scope.backgroundType = 'color';

                canvas.setBackgroundColor(ProductService.getPreviewBgColor(), function () {
                    canvas.renderAll();

                    $scope.backgroundReady = true;
                    if ($scope.step1HasStarMaps()) {
                        starMapUtils.showCelestialContainer().then(() => {
                            loadProduct().then(() => {
                                //show only first group when the step is done loading
                                if ($scope.layersInstance) {
                                    $scope.layersInstance.$children[0].singleGroupSelection();
                                    $scope.deselectAll();
                                }
                                // apply text masks
                                $scope.applyTextMasks();
                                blockUI.stop();
                                $timeout(() => $scope.$apply());
                            });
                        });
                    } else {
                        loadProduct().then(() => {
                            //show only first group when the step is done loading
                            if ($scope.layersInstance) {
                                if (!$scope.enablePageEps) $scope.layersInstance.$children[0].singleGroupSelection();
                                $scope.deselectAll();
                            }
                            blockUI.stop();
                            $timeout(() => $scope.$apply());
                        });
                    }
                });
            }
        } else if ($scope.forProductTemplateCreation && ProductService.getProductTemplatePreviewTargetSize()) {
            const { width, height } = ProductService.getProductTemplatePreviewTargetSize();
            $scope.setBackgroundColor(width, height, 'rgba(255, 255, 255, 1)');
        }

        function synchronizeProperties(elements, epsElements, properties) {
            if (!elements.length || !epsElements.length) {
                return;
            }

            for (const element of elements) {
                const epsElement = epsElements.find((e) => e.uuid === element.uuid);
                if (!epsElement) {
                    continue;
                }

                for (const prop of properties) {
                    element[prop] = epsElement[prop];
                }
            }
            $scope.$applyAsync();
        }

        function loadProduct(forceReload) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                try {
                    $scope.fonts = fontManagerService.loadedFonts;

                    const listEPS = ProductService.getListEPS();
                    const imagePlaceHoldersEpsList = listEPS.map((s) => s.imagePlaceHoldersEps).flat();
                    const textsEpsList = listEPS.map((s) => s.textsEps).flat();
                    const circularTextsEpsList = listEPS.map((s) => s.circularTextsEps).flat();
                    const vectorEPSEpsList = listEPS.map((s) => s.vectorEPSEps).flat();

                    const imagePlaceHolders =
                        !forceReload && ($scope.previewMode || $scope.editMode)
                            ? ProductService.getProduct().preview.imagePlaceHoldersPreview
                            : cloneDeep(imagePlaceHoldersEpsList);

                    if (imagePlaceHolders.some((i) => i.CrosswordConfig != null)) {
                        $scope.loadCrosswordTextures();
                    }

                    // If this is the first time we are creating the preview (or we are forced to reload it), check if we have dynamic images that are too big for the preview. We don't check again when the
                    //  product is edited because adding/removing images in step 1 doesn't update them in step 2 anymore
                    if (forceReload || (!$scope.previewMode && !$scope.editMode)) {
                        // Check if dynamic images need resizing
                        const prodDynamicImages = (imagePlaceHoldersEpsList || []).filter((i) => i.dynamicImagesPath);
                        if (prodDynamicImages.length) {
                            Sentry.addBreadcrumb({
                                type: 'info',
                                category: 'template.step2',
                                message: 'Checking images size',
                                level: 'info'
                            });

                            await DynamicImageService.limitDynamicImageFileSizes(
                                prodDynamicImages,
                                (imagePlaceHolders || []).filter((i) => i.dynamicImagesPath),
                                $scope.MAX_IMAGE_SIZE
                            );
                        }

                        // Check if mask images need resizing
                        const prodImagePlaceholders = (imagePlaceHoldersEpsList || []).filter(
                            (i) => !i.dynamicImagesPath && i.maskPath
                        );
                        if (prodImagePlaceholders.length) {
                            await ImageUtilService.limitMaskImagesSize(
                                prodImagePlaceholders,
                                (imagePlaceHolders || []).filter((i) => !i.dynamicImagesPath && i.maskPath),
                                $scope.MAX_IMAGE_SIZE
                            );
                        }
                    } else {
                        // if we are editing a template and change the test image on a image placeholder on step1
                        // we insert the new test image to the preview element so it changes there too
                        const epsMap = new Map(imagePlaceHoldersEpsList.map((a) => [a.uuid, a]));
                        for (const imagePlaceHolder of imagePlaceHolders) {
                            if (
                                !imagePlaceHolder.dynamicImagesPath &&
                                !imagePlaceHolder.mapConfig &&
                                !imagePlaceHolder.starMapConfig &&
                                !imagePlaceHolder.calendar
                            ) {
                                const found = epsMap.get(imagePlaceHolder.uuid);
                                if (!found) continue;
                                imagePlaceHolder.testingUrl = found.testingUrl;
                            }
                        }
                    }

                    console.log(`Artwork size is ${canvas.getArtworkWidth()}x${canvas.getArtworkHeight()}px`);

                    // Load all the elements into the canvas
                    const loadFromStep1 = forceReload || (!$scope.previewMode && !$scope.editMode);
                    const texts = !loadFromStep1 ? ProductService.getProduct().preview.textsPreview : textsEpsList;
                    const circularTexts = !loadFromStep1
                        ? ProductService.getProduct().preview.circularTextsPreview
                        : circularTextsEpsList;
                    const vectorsEps = !loadFromStep1
                        ? ProductService.getProduct().preview.vectorEPSPreview
                        : vectorEPSEpsList;
                    const groups = !loadFromStep1
                        ? ProductService.getGroups().filter((g) => g.type === 'preview')
                        : ProductService.getGroups().filter((g) => g.type === 'eps');

                    const childTemplateProduct = ProductService.getChildTemplateProduct();

                    if (!loadFromStep1) {
                        $scope.$applyAsync();
                        synchronizeProperties(
                            [...(circularTexts ?? []), ...(texts ?? [])],
                            [...(circularTextsEpsList ?? []), ...(textsEpsList ?? [])],
                            ['fontsMap']
                        );
                    }

                    const comesFromStep1 = $rootScope?.lastLocation?.includes('/createProduct1') || false;

                    await PreviewUtilService.loadStep2IntoCanvas(
                        canvas,
                        $scope.fonts,
                        $scope.previewMode,
                        $rootScope.user.Username,
                        texts,
                        circularTexts,
                        imagePlaceHolders,
                        vectorsEps,
                        loadFromStep1,
                        ProductService.getNeedColorsUpgrade(),
                        $scope.forProductTemplateCreation,
                        ProductService.getPreviewColorOptionsMetadata(),
                        groups,
                        $scope.forMyProductBases,
                        childTemplateProduct && childTemplateProduct.parentId,
                        listEPS,
                        ProductService.getGroups().filter((g) => g.type === 'eps'),
                        comesFromStep1,
                        $scope.editMode
                    );

                    $scope.deselectAll();
                    if ($scope.undoManager) $scope.undoManager.clear();
                    $timeout(() => {
                        $scope.$apply();
                        if ($scope.layersInstance) {
                            $scope.layersInstance.$children[0].initGroupSelectionFromPageEps();
                        }
                        $rootScope.$broadcast('canvas:loaded:stepThree');
                    });

                    // apply text masks
                    await $scope.applyTextMasks();
                    resolve();
                } catch (error) {
                    console.error(error);
                    reject(error);
                }
            });
        }

        $scope.template = ProductService.getProduct();

        $scope.deselectAll = function () {
            canvas.discardActiveObject().renderAll();
            $scope.textSelected = null;
            $scope.imageSelected = null;
        };

        $scope.showResizedAlert = async function () {
            await $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(false)
                    .title('Large Images')
                    .htmlContent(
                        `At least one image has a size bigger than <b>${$scope.MAX_IMAGE_SIZE} px</b> which can result in bad performance and slow loading times on your store! It will be scaled down!`
                    )
                    .ok('OK!')
            );
        };

        $scope.uploadImagesOnPlaceholder = async function (fileObject, isPlaceholder) {
            const files = [];
            let hasResizedImages = false;

            if (!isPlaceholder) {
                // Make sure all the images are below the max image size
                for (const file of fileObject.files) {
                    const result = await ImageUtilService.limitImageResolutionFromFile(
                        file,
                        $scope.MAX_IMAGE_SIZE,
                        $scope.MAX_IMAGE_SIZE
                    );
                    hasResizedImages = hasResizedImages || result.resized;
                    files.push(result.file);
                }
            } else {
                files.push(fileObject.files[0]);
            }

            $scope.imageSelected.imageFile = files[0];

            const object = canvas.getActiveObject();
            let firstStepPlaceholder;
            if (isPlaceholder) {
                const firstStepElements = ProductService.getEps(object.pageEpsId);
                firstStepPlaceholder = firstStepElements.imagePlaceHoldersEps.find(
                    (imagePlaceholderObject) => imagePlaceholderObject.uuid === object.uuid
                );
            }
            if ($scope.imageSelected.dynamicImagesPath) {
                $scope.imageSelected = null;
            }

            await MultipleFileUploadService.uploadMultipleImages(
                $scope,
                canvas,
                files,
                object,
                true,
                isPlaceholder,
                firstStepPlaceholder
            );

            if ($scope.selectedImageProperties.cartoonize && $scope.apiKeys.vanceAi) await $scope.cartoonize();

            if ($scope.selectedImageProperties.CutoutFace && $scope.apiKeys.cutoutPro) await $scope.faceCutout(true);

            if ($scope.selectedImageProperties.removeBackgroundCOP && $scope.apiKeys.cutoutPro)
                await $scope.faceCutout(false);

            if ($scope.selectedImageProperties.RemoveBackground && $scope.apiKeys.removeBg) await $scope.removeBg();

            if ($scope.selectedImageProperties.CustomilyRemoveBackground) await $scope.customilyRmbg();

            if ($scope.selectedImageProperties.CustomilyFaceCutOut) await $scope.CustomilyFaceCutOut();

            if ($scope.selectedImageProperties.CustomilyImageFilter)
                await $scope.CustomilyImageFilter($scope.imageSelected.CustomilyImageFilter);

            if (object.imageEffects?.length) {
                try {
                    $scope.showBlockUiLoader(true, 'Transforming your image 📝✨🎨');
                    await ImageEffectsService.processImageEffects({
                        object,
                        canvas,
                        username: $rootScope.user.Username,
                        file: $scope.imageSelected.imageFile
                    });
                } catch (error) {
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('We received an error:')
                            .htmlContent(error.message)
                            .ok('OK!')
                    );
                } finally {
                    $scope.showBlockUiLoader(false);
                }
            }

            fileObject.value = null;

            // process text mask
            TextService.processTextMask(canvas, [$scope.selectedImageProperties]);

            $timeout(() => {
                $scope.imageSelected = object;
                $scope.$apply();
            });
        };

        $scope.resetImageTestValue = async function () {
            const targetObject = canvas.getActiveObject();
            const object = canvas.getObjects().find((o) => o.uuid === targetObject.uuid);
            targetObject.testingUrl = '';
            TestImageService.showStaticImage(canvas, object, {
                imageUrl: require('@/assets/images/photo-example.png')
            });

            const product = ProductService.getProduct();
            const stepOneImagePlaceholders = product.listEPS.map((eps) => eps.imagePlaceHoldersEps).flat();
            const targetStepOneObject = stepOneImagePlaceholders.find((sOneImgPh) => sOneImgPh.uuid === object.uuid);
            if (targetStepOneObject) targetStepOneObject.testingUrl = '';
            $scope.IndexDbService.findAndEditValue(object.uuid, '');
        };

        $scope.trustedTestSvg = '';

        $scope.resetSvgTestValue = async function () {
            const { selectedSVGProperties } = $scope;
            const targetObject = canvas.getActiveObject();
            const object = canvas
                .getObjects()
                .find((o) => o.uuid === targetObject.uuid && o.type === 'vector-placeholder');
            TestImageService.showStaticImageSvg(canvas, object, {
                imageUrl: require('@/assets/images/vector-example.svg')
            });
            selectedSVGProperties.svgString = '';
            $scope.trustedTestSvg = '';

            const product = ProductService.getProduct();
            const stepOneVectorPlaceholders = product.listEPS.map((eps) => eps.vectorEPSEps).flat();
            const targetStepOneObject = stepOneVectorPlaceholders.find(
                (sOneVectorPh) => sOneVectorPh.uuid === object.uuid
            );
            if (targetStepOneObject) targetStepOneObject.svgString = '';
            $scope.IndexDbService.findAndEditValue(object.uuid, '');
        };

        $scope.$watch('svgSelected.svgString', function (newVal) {
            if (newVal && !/^<!--\s*default customily vector\s*-->/.test(newVal.trim())) {
                $scope.trustedTestSvg = $sce.trustAsResourceUrl(
                    'data:image/svg+xml;utf8,' + encodeURIComponent(newVal)
                );
            } else {
                $scope.trustedTestSvg = '';
            }
        });

        $scope.addDynamicImage = function (event) {
            const image = DynamicImageService.createDynamicImage(canvas, $scope.getLastObjectId() + 1, {
                pageEpsId: null,
                addedOnEdit: $scope.editMode,
                zIndex: canvas.getHighestZIndex() + 1
            });

            canvas.add(image);
            canvas.setActiveObject(image, event);

            setTimeout(() => {
                updateElementsOrderFromZIndex(canvas);
            });

            return image;
        };

        /**
         * This method transforms the given Vector EPS object to a dynamic image and asks the user to upload
         *  and image to use
         * @param {Object} svgObject Vector EPS object to transform
         */
        $scope.convertVectorEPSOverlay = function (svgObject, event) {
            svgObject ||= $scope.svgSelected;

            // Add a dynamic image
            const addedImage = $scope.addDynamicImage();

            // Replace the ID and UUID of the added image with the ID of the Vector EPS
            addedImage.set('id', svgObject.id);
            addedImage.set('uuid', svgObject.uuid);
            addedImage.set('pageEpsId', svgObject.pageEpsId);
            addedImage.set('groupId', svgObject.groupId);
            addedImage.set('zIndex', svgObject.zIndex);
            canvas.requestRenderAll();

            // Remove the Vector EPS
            setTimeout(() => {
                canvas.remove(svgObject);
                canvas.requestRenderAll();

                // Deselect and re-select the object to update the properties
                canvas.discardActiveObject();
                canvas.setActiveObject(addedImage, event);

                // Trigger the image upload button for the added dynamic image
                $("form[name='imageForm'] [input-id='inputFileTest']").click();
            }, 200);
        };

        $scope.changeFontOption = function () {
            MultipleFontService.changeFontOptionPreview(
                canvas.getActiveObject(),
                $scope.selectedTextProperties.fontOption,
                canvas
            );
        };

        $scope.changeFontTexture = function (texturePath, textSelected) {
            const object = textSelected || canvas.getActiveObject();
            if (!texturePath || texturePath === 'null') {
                texturePath = null;
            }
            // dirty way to make vue detect the change on text selected variable
            $scope.textSelected = { ...object };
            TextureService.changeFontTexture(texturePath, object, 1).then(() => {
                $scope.$apply(() => {
                    $scope.textSelected = object;
                });
                canvas.renderAll();
            });
        };

        $scope.changeTextureScale = function (textureScale, textSelected) {
            TextureService.changeScaleTexture(textSelected, 1, textureScale || 100).then(() => {
                canvas.renderAll();
            });
        };

        $scope.changeDynamicImageColorPosition = function () {
            DynamicImageService.changeDynamicImageColorPosition(
                canvas.getActiveObject(),
                $scope.selectedImageProperties.colorPosition,
                $scope.imageColorPicker,
                canvas
            );
        };

        $scope.removeBg = async function () {
            // This method does not update oldImage since the control to swap it does not exist.
            blockUI.start('Removing background');
            try {
                const response = await RemoveBgAPIService.removeBackground(
                    $scope.apiKeys.removeBg,
                    $scope.imageSelected.imageFile
                );
                $scope.imageSelected.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response]);
            } catch (error) {
                window.rumReportError(error);
                $timeout(() => $scope.$apply());
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('Remove.bg Error: ' + error.statusText)
                        .textContent(
                            'Configuration is saved! But image without background it is not shown in the placeholder'
                        )
                        .ok('OK!')
                );
            } finally {
                blockUI.stop();
            }
        };

        $scope.cartoonize = async () => {
            blockUI.start('Applying filter');
            try {
                const response = await ImageFiltersAPIService.cartoonizeImage(
                    $scope.apiKeys.vanceAi,
                    $scope.imageSelected.imageFile
                );
                $scope.imageSelected.imageFile = response;
                await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response]);
            } catch (error) {
                window.rumReportError(error);
                $timeout(() => $scope.$apply());
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('VanceAI Error!')
                        .textContent(
                            error.msg ||
                                error ||
                                'There seems to be an error with your VanceAI account, so the filter could not be applied to the image.'
                        )
                        .ok('OK!')
                );
            } finally {
                blockUI.stop();
            }
        };

        $scope.faceCutout = async function (cutFace) {
            await CutoutProUtilService.faceCutout($scope, canvas, cutFace, true);
        };

        $scope.customilyRmbg = async function () {
            await CustomilyRmbgService.applyFilter(undefined, $scope, canvas);
        };

        $scope.CustomilyFaceCutOut = async function () {
            await CustomilyFaceCutOutService.applyFilter(undefined, $scope, canvas);
        };

        $scope.templateProductColorHasDynamicImages = () => {
            const productColorsElement = ProductService.getProduct().preview.imagePlaceHoldersPreview.find(
                (i) => i.isColorOptions
            );
            //here we are validating if the user is uploading at least one image in the product colors imagePlaceHolder
            if (productColorsElement && JSON.parse(productColorsElement.dynamicImagesPath).length) return true;

            const dialog = $scope.forMyProductBases
                ? {
                      title: 'Alert',
                      msg:
                          'We can’t find any produt images. Please make sure you upload your product images before moving forward'
                  }
                : {
                      title: `Please upload image on ${productColorsElement.name}`,
                      msg: 'Upload at least 1 image'
                  };

            $mdDialog.show(
                $mdDialog
                    .alert()
                    .parent(document.body)
                    .clickOutsideToClose(true)
                    .title(dialog.title)
                    .textContent(dialog.msg)
                    .ok('OK!')
            );
            return false;
        };

        $scope.CustomilyImageFilter = async function (filter) {
            await CustomilyImageFilterService.applyFilter(undefined, filter, $scope, canvas);
        };

        $scope.goToStep3 = async function () {
            // Save all the data
            blockUI.start('Saving data');

            await PreviewUtilService.saveStep2(
                canvas,
                $scope.isManagedUser,
                $scope.editMode,
                $scope.replacedBackground,
                $scope.backgroundImageFile,
                $scope.backgroundType
            );
            blockUI.stop();

            if ($scope.forProductTemplateCreation) {
                if (!$scope.templateProductColorHasDynamicImages()) return;
            }

            if ($scope.fromListing) {
                $location.path('/createProduct3').search({
                    fromListing: 'true',
                    fromPreview: 'true',
                    forProductTemplateCreation: 'true',
                    forMyProductBases: 'true'
                });
            } else if ($scope.isUserDesignCreation) {
                $location.path('/createProduct3').search({
                    forUserDesignCreation: 'true',
                    flowId: $location.search().flowId
                });
            } else {
                $location.path('/createProduct3');
            }
            $timeout(() => $scope.$apply());
        };

        $scope.displaySVGOnPlaceholder = async function (files) {
            if (files && files[0]) {
                const objects = canvas
                    .getObjects()
                    .filter(
                        (o) =>
                            o.id === canvas.getActiveObject().id && o.type === 'vector-placeholder' && o.allowUserUpload
                    );
                for (const object of objects) {
                    const firstStepElements = ProductService.getEps(object.pageEpsId);
                    const firstStepPlaceholder = firstStepElements.vectorEPSEps.find(
                        (vectorPlaceholderObject) => vectorPlaceholderObject.uuid === object.uuid
                    );
                    await DynamicVectorService.loadFileOnPlaceholder(
                        files[0],
                        object,
                        canvas,
                        true,
                        firstStepPlaceholder
                    );
                }
                $timeout(() => $scope.$apply());
            }
        };

        $scope.displayStringSVG = function (svgString, object, canvas) {
            if (!svgString.length) return;
            DynamicVectorService.loadSVGStringOnPlaceholder(svgString, object, canvas);
            $timeout(() => $scope.$apply());
        };

        $scope.updateQrText = async function (newText) {
            if ($scope.svgSelected) {
                const newConfig = { ...$scope.svgSelected.qrConfig, text: newText };
                $scope.displayQrWithConfig(newConfig, $scope.svgSelected);
            }
        };

        $scope.displayQrWithConfig = async (config = {}, object) => {
            var mutex = ProductService.getQrMutex();
            const content = await QrUtilService.getQrSvg(config, mutex);
            $scope.displayStringSVG(content, object, canvas);
        };

        /****************************************************************************/
        /****************************** PARAMETERS UPDATE ***************************/
        /****************************************************************************/
        $scope.updateText = function (text, object) {
            TextService.updateTexts(text, object, canvas);
            $scope.IndexDbService.findAndEditValue(object.uuid, text);

            $scope.selectedTextProperties.currentFontSize = fabric.util.pxToPt(
                object.getFontSize && object.getFontSize()
            );
            $scope.selectedTextProperties.text = object.getText ? object.getText() : object.text;

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateCenterX = function (px = 0, object) {
            if (object.isType('activeSelection')) {
                const point = object.getPointByOrigin('center', 'center');
                point.setX(px);
                object.setPositionByOrigin(point, 'center', 'center');
            } else {
                object.set('left', px);
            }

            object.setCoords();
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipCenterX: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateCenterY = function (px = 0, object) {
            if (object.isType('activeSelection')) {
                const point = object.getPointByOrigin('center', 'center');
                point.setY(px);
                object.setPositionByOrigin(point, 'center', 'center');
            } else {
                object.set('top', px);
            }
            object.setCoords();
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipCenterY: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateRotation = function (degrees = 0, object) {
            if (object.isType('activeSelection')) {
                object.rotate(degrees);
            } else {
                object.set('angle', degrees);
            }

            object.setCoords();
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipRotation: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateMinSizePx = function (size = 0, object) {
            object.setMinSizePx(size);
            canvas.renderAll();
        };

        $scope.updateMaxSizePx = function (size = 0, object) {
            object.setMaxSizePx(size);
            canvas.renderAll();
        };

        $scope.updateOpacity = function (opacity, object) {
            object.setOpacity(opacity);
            canvas.renderAll();
        };

        $scope.updateSkewX = function (skew = 0, object) {
            object.set('skewX', skew);
            object.setCoords();
            canvas.renderAll();
        };

        $scope.updateSkewY = function (skew = 0, object) {
            object.set('skewY', skew);
            object.setCoords();
            canvas.renderAll();
        };

        $scope.updateHeight = function (px = 1, object, linked) {
            if (!px) return;
            var ratio = (object.width * object.scaleX) / (object.height * object.scaleY);

            if (object.isType('activeSelection')) {
                // The height property of an ActiveSelection always remains static, while getScaledHeight changes!
                // Use the static height as the reference to calculate the new scale
                const newScale = px / object.height;
                object.scale(newScale);
            } else if (object.type === 'path-itext') {
                ratio = (object.horizontalDiameter * object.scaleX) / (object.verticalDiameter * object.scaleY);
                object.set('verticalDiameter', px);
            } else {
                if (object.setHeight) {
                    object.setHeight(px);
                } else {
                    object.set('height', px / object.scaleY);
                }
            }

            object.setCoords();
            if ($scope.editMode) {
                object.editedSize = true;
            }

            // If linked, update width too, maintaining aspect ratio
            if (linked) {
                $scope.updateWidth(ratio * px, object);
                if ($scope.textSelected) {
                    //this could be included in BoundedText.js altough I'm not sure how it could
                    //impact the performance (same goes to $scope.updateWidth)
                    const size = GeneralMathUtils.calculateFontSizesFromObject($scope.textSelected);
                    $scope.textSelected.setMinSizePx(size.min);
                    $scope.textSelected.setMaxSizePx(size.max);

                    if ($scope.textSelected.allowEdit && $scope.textSelected.originalInitCenterX != null) {
                        const values = GeneralMathUtils.calculateInitTextValuesFromObject($scope.textSelected);
                        $scope.textSelected.setInitPositionAndSize(
                            values.initCenterX,
                            values.initCenterY,
                            values.initFontSize
                        );
                    }
                }
            }
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipHeight: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateWidth = function (px = 1, object, linked) {
            var ratio = (object.width * object.scaleX) / (object.height * object.scaleY);

            if (object.isType('activeSelection')) {
                // The width property of an ActiveSelection always remains static, while getScaledWidth changes!
                // Use the static width as the reference to calculate the new scale
                const newScale = px / object.width;
                object.scale(newScale);
            } else if (object.type === 'path-itext') {
                ratio = (object.horizontalDiameter * object.scaleX) / (object.verticalDiameter * object.scaleY);
                object.set('horizontalDiameter', px);
            } else {
                if (object.setWidth) {
                    object.setWidth(px);
                } else {
                    object.set('width', px / object.scaleX);
                }
            }

            object.setCoords();
            if ($scope.editMode) {
                object.editedSize = true;
            }

            // If linked, update height too, maintaining aspect ratio
            if (linked) {
                $scope.updateHeight(px / ratio, object);
                if ($scope.textSelected) {
                    const size = GeneralMathUtils.calculateFontSizesFromObject($scope.textSelected);
                    $scope.textSelected.setMinSizePx(size.min);
                    $scope.textSelected.setMaxSizePx(size.max);

                    if ($scope.textSelected.allowEdit && $scope.textSelected.originalInitCenterX != null) {
                        const values = GeneralMathUtils.calculateInitTextValuesFromObject($scope.textSelected);
                        $scope.textSelected.setInitPositionAndSize(
                            values.initCenterX,
                            values.initCenterY,
                            values.initFontSize
                        );
                    }
                }
            }
            canvas.renderAll();

            if (object.isType('activeSelection')) {
                canvas.fire('customilyActiveSelection:modified', { skipWidth: true });
            }

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateZIndex = async function (zIndex, object) {
            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    let newZIndex = o.zIndex + zIndex;

                    // Z index can't go over the length of the list
                    if (newZIndex < 0) newZIndex = 0;
                    else if (newZIndex > canvas.getObjects().length - 1) newZIndex = canvas.getObjects().length - 1;

                    // Set the z index for this object
                    o.zIndex = newZIndex;
                    canvas.moveTo(o, newZIndex);
                });
            } else {
                // Z index can't go over the length of the list
                if (zIndex < 0) zIndex = 0;
                else if (zIndex > canvas.getObjects().length - 1) zIndex = canvas.getObjects().length - 1;

                // Set the z index for this object
                object.zIndex = zIndex;
                canvas.moveTo(object, zIndex);
            }

            canvas.renderAll();

            // update text masks
            await $scope.handleTextAsMaskOnZIndexUpdated();
        };

        $scope.updateFlipX = function (object) {
            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    $scope.updateFlipX(o);
                });

                return;
            }

            const flip = object.getFlip();
            object.setFlip(!flip.flipX, flip.flipY);
            object.setCoords();
            canvas.renderAll();

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.updateFlipY = function (object) {
            if (object.isType('activeSelection')) {
                object.getObjects()?.forEach((o) => {
                    $scope.updateFlipY(o);
                });

                return;
            }

            const flip = object.getFlip();
            object.setFlip(flip.flipX, !flip.flipY);
            object.setCoords();
            canvas.renderAll();

            // apply text mask
            canvas.fire('object:handle:textmask', { target: object });
        };

        $scope.togglePerspective = function (object) {
            if (object.togglePerspective) {
                object.enablePerspective = true;
                object.togglePerspective(!object.__perspectiveMode);
                $scope.selectedImageProperties.statusPerspectiveMode = object.__perspectiveMode;
            }
        };

        $scope.resetPerspective = function (object) {
            if (object._removePerspective) {
                object._removePerspective();
                $scope.selectedImageProperties.enablePerspective = false;
                $scope.selectedImageProperties.statusPerspectiveMode = object.__perspectiveMode;
            }
        };

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Color pickers                                                                       ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        var cancelNextImageColorChangeDebounced = false;
        var debouncedImageColorChange = _.debounce(function (colors, imageSelected) {
            if (!cancelNextImageColorChangeDebounced && imageSelected) {
                imageSelected.set('imageColor', '#' + colors.HEX);
                canvas.renderAll();
            }
            cancelNextImageColorChangeDebounced = false;
        }, 300);
        $scope.imageColorChange = function (colors, isTerminating) {
            if (isTerminating && $scope.imageSelected) {
                $scope.imageSelected.set('imageColor', '#' + colors.HEX);
                canvas.renderAll();
            } else {
                debouncedImageColorChange(colors, $scope.imageSelected);
            }
        };

        $scope.imageColorSave = function (colors, image) {
            image = image || $scope.imageSelected;
            const { selectedImageProperties, editMode } = $scope;
            if (image?.isPrintArea) {
                image.fullColor = false;
                image.grading = false;
                image.imageType = 'single color';
                selectedImageProperties.fullColor = false;
                selectedImageProperties.grading = false;
                image.setMode(fabric.IMAGE_MODE_SINGLE_COLOR);
                image.colors = undefined;
                image.colorLibraryId = undefined;
                if (editMode) {
                    image.setEditedProp('fullColor', 'grading', 'colors', 'colorLibraryId', 'imageType');
                }
            }
            if (image) {
                DynamicImageService.saveDynamicImageColor(colors, image, editMode);
                image.set('imageColor', '#' + colors.HEX);
                canvas.renderAll();
            }
        };

        $scope.startFillColorSampler = function (colorPicker) {
            $scope.colorSamplerActive = true;
            ColorSamplerService.startColorSampler(canvas, colorPicker, canvas.getActiveObject(), 'fill');
        };

        $scope.startOutlineColorSampler = function (colorPicker) {
            $scope.colorSamplerActive = true;
            ColorSamplerService.startColorSampler(canvas, colorPicker, canvas.getActiveObject(), 'outline');
        };

        //product base creation
        $scope.applyMask = function (fileObject) {
            $scope.selectedImageProperties.clipPath.scaleX = 1;
            const svgFile = fileObject.files[0];
            const reader = new FileReader();
            const selectedImage = canvas.getActiveObject();

            reader.onloadend = function (e) {
                var svgData = e.target.result;
                var parser = new DOMParser();
                var doc = parser.parseFromString(svgData, 'image/svg+xml');
                const maskPath = [...doc.querySelectorAll('path')].map((path) => path.getAttribute('d'))[0];
                const mask = new fabric.Path(maskPath, {
                    left: 0, // Center of the canvas
                    top: 0, // Center of the canvas
                    originX: 'center',
                    originY: 'center'
                });
                selectedImage.clipPath = mask;
                //force image redraw for mask to be applied inmedialty
                selectedImage.set('dirty', true);
                canvas.renderAll();
            };
            reader.readAsText(svgFile);
        };

        $scope.changeMaskScale = function (maskSize) {
            const selectedImage = canvas.getActiveObject();
            selectedImage.clipPath.scale(maskSize);
            selectedImage.set('dirty', true);
            canvas.renderAll();
        };

        $scope.changeMaskXY = function (x, y) {
            const selectedImage = canvas.getActiveObject();
            selectedImage.clipPath.left = x;
            selectedImage.clipPath.top = y;
            selectedImage.set('dirty', true);
            canvas.renderAll();
        };

        /****************************************************************************/
        /****************************** AUX FUNCTIONS *******************************/
        /****************************************************************************/
        $scope.getLastObjectId = function () {
            let objects = canvas.getObjects();
            let id = 0;
            for (let n = 0; n < objects.length; ++n) {
                id = Math.max(id, objects[n].id);
            }
            return id;
        };

        $scope.updateId = function (newId, object) {
            if (newId) {
                object.id = newId;
            }
        };

        // Cleanup
        $scope.$on('$destroy', function () {
            console.log('Cleaning up resources from step 2');

            $scope.bgColorPickerCtrlMethods.destroy();
            $scope.imageColorPicker.destroy();
            $scope.imageOutlineColorPicker.destroy();

            blockUI.stop();

            if (canvas) {
                // Remove the canvas element so the next controller won't be able to find it
                canvas.dispose();
                $('#fabric-container-2').remove();
            }
        });

        ///////////////////////////////////////////////////////////////////////////////////////////
        /// Libraries                                                                           ///
        ///////////////////////////////////////////////////////////////////////////////////////////
        $scope.pickColorLibrary = async function (canvasObject, loadInfo = true) {
            return LibrariesUtilService.showColorLibraryPicker().then(function (library) {
                if (library) {
                    canvasObject.colorLibraryId = library.LibraryId;

                    if (!loadInfo) return;

                    // Select the first color from the library
                    if (canvasObject.type === 'image-placeholder') {
                        $scope.selectedImageProperties.colorPosition = 1;
                        DynamicImageService.changeDynamicImageColorPosition(
                            canvasObject,
                            1,
                            $scope.imageColorPicker,
                            canvas
                        );
                    }

                    // Get the name of the selected library
                    LibrariesAPIService.getLibraryName(library.LibraryId).then(function (name) {
                        $scope.selectedColorLibraryName = name;
                    });
                }
            });
        };

        $scope.pickColorLibraryForSelectedVector = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize vectorSelected in order for vue component to detect the change
            $scope.svgSelected = null;
            await $scope.pickColorLibrary(object, false);

            $scope.svgSelected = object;
            $scope.$apply();
        };

        $scope.pickColorLibraryForSelectedText = function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                object.colorLibraryId = library?.LibraryId;
                $scope.textSelected = object;
                $scope.$apply();
            });
        };

        $scope.pickOutlineColorLibraryForSelectedText = function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                object.outlineColorLibraryId = library?.LibraryId;
                $scope.textSelected = object;
                $scope.$apply();
            });
        };

        $scope.pickStrokeColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            const library = await LibrariesUtilService.showColorLibraryPicker();

            if (!library) {
                $scope.textSelected = object;
                return;
            }

            object.strokeColorLibraryId = library.LibraryId;

            $scope.textSelected = object;
            $scope.$apply();
        };

        $scope.pickShadowColorLibraryForSelectedText = async function () {
            const object = canvas.getActiveObject();
            $scope.textSelected = null;
            LibrariesUtilService.showColorLibraryPicker().then((library) => {
                object.shadowColorLibraryId = library?.LibraryId;
                $scope.textSelected = object;
                $scope.$apply();
            });
        };

        $scope.removeColorLibrary = function (canvasObject) {
            canvasObject.colorLibraryId = null;

            // Reset the position to 1 when removing the library
            if (canvasObject.type === 'image-placeholder') {
                $scope.selectedImageProperties.colorPosition = 1;
                DynamicImageService.changeDynamicImageColorPosition(canvasObject, 1, $scope.imageColorPicker, canvas);
            }
        };

        $scope.pickImageLibraryForSelectedImage = async function () {
            const object = canvas.getActiveObject();
            // Re-initialize imageSelected in order for vue component to detect the change
            $scope.imageSelected = null;
            const library = await LibrariesUtilService.showImageLibraryPicker();

            if (!library) {
                $scope.imageSelected = object;
                return;
            }

            object.imageLibraryId = library.LibraryId;

            $scope.imageSelected = object;
            $scope.$apply();
        };

        $scope.showPlaceholderImgForSelectedImage = function (dynamicImage = null) {
            const image = dynamicImage || canvas.getActiveObject();
            DynamicImageService.showSampleDynamicImage(canvas, image);
        };

        $scope.updateProductColorMetadata = function (imageFiles) {
            if (ProductService.getPod()) {
                ProductService.setIsProductColorModified(true);
            }
            ProductService.setProductColorsFilenames(imageFiles);
            // process text mask
            TextService.processTextMask(canvas, [$scope.imageSelected]);
        };

        $scope.downloadCurrentCanvasAsImage = async function () {
            if (!canvas) return;
            await handleDownloadCurrentCanvasAsImage(canvas, ProductService.getProduct().name);
        };

        $scope.selectInnerRectangle = function (activeObject) {
            activeObject.fire('object:dblclick');
        };

        $scope.onCalendarDateChange = () => {
            $scope._generateCustomilyCalendar($scope.imageSelected);
        };

        $scope.customilyCalendar = {
            date: new Date()
        };

        $scope._generateCustomilyCalendar = _.debounce(async function (object) {
            try {
                const output = await generateCustomilyCalendar(object, $scope.customilyCalendar.date);
                TestImageService.showStaticImage(canvas, object, {
                    imageUrl: output
                });
                return output;
            } catch (error) {
                console.error('generateCustomilyCalendar', error);
            }
        }, 200);

        $scope.handleTextAsMaskOnZIndexUpdated = async function () {
            // update text masks
            const objects = canvas._objects.filter((o) => o.type === 'bounded-text' && o.useAsMask);
            for (const object of objects) {
                await $scope.updateTextUseAsMask(false, object, true);
                await $scope.updateTextUseAsMask(true, object, true);
            }
        };

        $scope.updateTextUseAsMask = async function (useAsMask, object, reorderLayers = false) {
            if (reorderLayers) {
                await delay(1000);
            }

            if ($scope.editMode) {
                object.setEditedProp('useAsMask');
            }
            object.set('useAsMask', useAsMask);

            if (useAsMask) {
                // store object before use as mask
                if (!$scope.textAsMaskStoredObjects[object.uuid]) {
                    $scope.textAsMaskStoredObjects[object.uuid] = {
                        fontColor: object.getColor(),
                        strokeColor: object.getOutlineColor(),
                        strokeWidth: object.getOutlineWidth()
                    };
                }

                TextService.setTextMaskColor(canvas, $scope, object);
                TextService.setTextMaskStroke(canvas, $scope, object);

                // do apply mask
                object.text = object.text || 'A';
                await $scope.applyTextMask(object.uuid);
            } else {
                // remove useAsMask
                const targetObject = canvas._objects.find((o) => o.textMaskUuid === object.uuid);
                if (targetObject) {
                    await $scope.removeTextMask(targetObject, object);
                }
                // update text zIndex
                updateElementsOrderFromZIndex(canvas);
            }
        };

        $scope.applyTextMask = async function (textMaskUuid = '') {
            const result = await TextService.applyTextMask(canvas, textMaskUuid);
            if (!result.applied && result.targetObject) {
                await $scope.removeTextMask(result.targetObject);
            }
        };

        $scope.applyTextMasks = async function () {
            for (const object of canvas._objects.filter((o) => o.type === 'bounded-text' && o.useAsMask)) {
                // apply text mask
                await $scope.updateTextUseAsMask(true, object);
            }
        };

        $scope.removeTextMask = async function (targetObject, textObject) {
            await TextService.removeTextMask(canvas, $scope, targetObject, textObject);

            if (targetObject.dynamicImagesPath) {
                await DynamicImageService.showDynamicImage(
                    canvas,
                    targetObject,
                    targetObject.dynamicImageVariation || 1
                );
            } else {
                TestImageService.showStaticImage(canvas, targetObject, {
                    imageUrl: targetObject.testingUrl || require('@/assets/images/photo-example.png')
                });
            }
        };

        if (!$scope.previewMode) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            $scope.$on('$locationChangeStart', function (event, next, current) {
                if (!next.includes('/createProduct')) {
                    if (
                        !confirm(
                            "You're about to exit the template. This means all changes will be lost, do you want to continue?"
                        )
                    ) {
                        event.preventDefault();
                        ProductService.clearChildTemplateProduct();
                        $location.url($location.path());
                    } else {
                        $location.url(`${new URL(next).pathname}`);
                        ProductService.clearProduct();
                    }
                }
                $rootScope.lastLocation = current;
            });
        }

        $scope.stepTwoLayersSettingsProps = {
            events: {
                toggleLock: $scope.layersElementLockToggle,
                toggleVisibility: $scope.layersElementVisibilityToggle,
                toggleOverlay: $scope.layersElementOverlayToggle,
                titleChanged: $scope.layersTitleChange
            },
            canvas: $scope.canvas
        };
    }
})();
